// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, type Options as Options2, type RequestResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AiApiChatStreamData, AiApiChatStreamErrors, AiApiChatStreamResponses, AiApiEmbeddingsData, AiApiEmbeddingsErrors, AiApiEmbeddingsResponses, AiApiListModelsData, AiApiListModelsErrors, AiApiListModelsResponses, AiApiSummaryPromptData, AiApiSummaryPromptErrors, AiApiSummaryPromptResponses, AiApiTagPromptData, AiApiTagPromptErrors, AiApiTagPromptResponses, AiApiTagStreamData, AiApiTagStreamErrors, AiApiTagStreamResponses, AiApiTranslateData, AiApiTranslateErrors, AiApiTranslateResponses, DataAddDirectoryHandlesData, DataAddDirectoryHandlesErrors, DataAddDirectoryHandlesResponses, DataAddDiscoverIgnoredData, DataAddDiscoverIgnoredErrors, DataAddDiscoverIgnoredResponses, DataAddTagChannelsData, DataAddTagChannelsErrors, DataAddTagChannelsResponses, DataBoostDirectoryData, DataBoostDirectoryErrors, DataBoostDirectoryResponses, DataBulkAssignSettingGroupData, DataBulkAssignSettingGroupErrors, DataBulkAssignSettingGroupResponses, DataBulkChannelTagsEndpointData, DataBulkChannelTagsEndpointErrors, DataBulkChannelTagsEndpointResponses, DataBulkFollowEventsData, DataBulkFollowEventsErrors, DataBulkFollowEventsResponses, DataBulkReresolveStartIdsEndpointData, DataBulkReresolveStartIdsEndpointErrors, DataBulkReresolveStartIdsEndpointResponses, DataBulkResetSyncEndpointData, DataBulkResetSyncEndpointErrors, DataBulkResetSyncEndpointResponses, DataBulkSyncSettingsEndpointData, DataBulkSyncSettingsEndpointErrors, DataBulkSyncSettingsEndpointResponses, DataBulkUpsertPostsRouteData, DataBulkUpsertPostsRouteErrors, DataBulkUpsertPostsRouteResponses, DataCancelBulkFollowData, DataCancelBulkFollowErrors, DataCancelBulkFollowResponses, DataCancelSummaryAttemptData, DataCancelSummaryAttemptErrors, DataCancelSummaryAttemptResponses, DataClearTableRouteData, DataClearTableRouteErrors, DataClearTableRouteResponses, DataCountArtifactsRouteData, DataCountArtifactsRouteErrors, DataCountArtifactsRouteResponses, DataCountDirectoryData, DataCountDirectoryErrors, DataCountDirectoryResponses, DataCreateDiscoverReportData, DataCreateDiscoverReportErrors, DataCreateDiscoverReportResponses, DataCreateLogsRouteData, DataCreateLogsRouteErrors, DataCreateLogsRouteResponses, DataCreateSettingGroupData, DataCreateSettingGroupErrors, DataCreateSettingGroupResponses, DataDbStatsData, DataDbStatsResponses, DataDeleteAiCredentialData, DataDeleteAiCredentialErrors, DataDeleteAiCredentialResponses, DataDeleteBotCredentialData, DataDeleteBotCredentialErrors, DataDeleteBotCredentialResponses, DataDeleteChannelData, DataDeleteChannelErrors, DataDeleteChannelResponses, DataDeleteChatDestinationData, DataDeleteChatDestinationErrors, DataDeleteChatDestinationResponses, DataDeleteChatSessionData, DataDeleteChatSessionErrors, DataDeleteChatSessionResponses, DataDeleteDiscoverReportData, DataDeleteDiscoverReportErrors, DataDeleteDiscoverReportResponses, DataDeleteSettingGroupData, DataDeleteSettingGroupErrors, DataDeleteSettingGroupResponses, DataDeleteSummaryData, DataDeleteSummaryErrors, DataDeleteSummaryResponses, DataDeleteTagData, DataDeleteTagErrors, DataDeleteTagResponses, DataDeleteTagRunData, DataDeleteTagRunErrors, DataDeleteTagRunResponses, DataDiscoverCandidatesData, DataDiscoverCandidatesErrors, DataDiscoverCandidatesResponses, DataDismissSummaryPartialData, DataDismissSummaryPartialErrors, DataDismissSummaryPartialResponses, DataExportDataData, DataExportDataErrors, DataExportDataResponses, DataGetArtifactSpreadRouteData, DataGetArtifactSpreadRouteErrors, DataGetArtifactSpreadRouteResponses, DataGetBulkFollowStatusData, DataGetBulkFollowStatusErrors, DataGetBulkFollowStatusResponses, DataGetChannelStatsData, DataGetChannelStatsErrors, DataGetChannelStatsResponses, DataGetChatSessionData, DataGetChatSessionErrors, DataGetChatSessionResponses, DataGetDirectoryDistributionData, DataGetDirectoryDistributionErrors, DataGetDirectoryDistributionResponses, DataGetDirectoryEntryData, DataGetDirectoryEntryErrors, DataGetDirectoryEntryResponses, DataGetDirectoryNeighboursData, DataGetDirectoryNeighboursErrors, DataGetDirectoryNeighboursResponses, DataGetDirectoryPostsData, DataGetDirectoryPostsErrors, DataGetDirectoryPostsResponses, DataGetDirectorySizeData, DataGetDirectorySizeResponses, DataGetDirectoryWhyData, DataGetDirectoryWhyErrors, DataGetDirectoryWhyResponses, DataGetDiscoverProbeQueueData, DataGetDiscoverProbeQueueResponses, DataGetDiscoverReportData, DataGetDiscoverReportErrors, DataGetDiscoverReportResponses, DataGetLogRouteData, DataGetLogRouteErrors, DataGetLogRouteResponses, DataGetLogSpreadRouteData, DataGetLogSpreadRouteErrors, DataGetLogSpreadRouteResponses, DataGetNetworkSettingsData, DataGetNetworkSettingsResponses, DataGetSettingData, DataGetSettingErrors, DataGetSettingResponses, DataGetSummaryData, DataGetSummaryErrors, DataGetSummaryResponses, DataGetSyncMetaRouteData, DataGetSyncMetaRouteResponses, DataGetTagRunData, DataGetTagRunErrors, DataGetTagRunResponses, DataGetTranslationData, DataGetTranslationErrors, DataGetTranslationResponses, DataImportDataData, DataImportDataErrors, DataImportDataResponses, DataKeepSummaryPartialData, DataKeepSummaryPartialErrors, DataKeepSummaryPartialResponses, DataListAiCredentialsData, DataListAiCredentialsResponses, DataListArtifactsData, DataListArtifactsErrors, DataListArtifactsResponses, DataListBotCredentialsData, DataListBotCredentialsResponses, DataListChannelBiosData, DataListChannelBiosResponses, DataListChannelsData, DataListChannelsErrors, DataListChannelsResponses, DataListChannelStatsData, DataListChannelStatsResponses, DataListChatDestinationsData, DataListChatDestinationsResponses, DataListChatSessionsData, DataListChatSessionsErrors, DataListChatSessionsResponses, DataListDirectoryColumnsData, DataListDirectoryColumnsResponses, DataListDirectoryData, DataListDirectoryErrors, DataListDirectoryHandlesData, DataListDirectoryHandlesErrors, DataListDirectoryHandlesResponses, DataListDirectoryResponses, DataListDiscoverIgnoredData, DataListDiscoverIgnoredResponses, DataListDiscoverProbesData, DataListDiscoverProbesErrors, DataListDiscoverProbesResponses, DataListDiscoverReportsData, DataListDiscoverReportsErrors, DataListDiscoverReportsResponses, DataListLogsRouteData, DataListLogsRouteErrors, DataListLogsRouteResponses, DataListPostsData, DataListPostsErrors, DataListPostsResponses, DataListSettingGroupsData, DataListSettingGroupsResponses, DataListSummariesData, DataListSummariesErrors, DataListSummariesResponses, DataListSummaryAttemptsData, DataListSummaryAttemptsErrors, DataListSummaryAttemptsResponses, DataListTagChannelsData, DataListTagChannelsErrors, DataListTagChannelsResponses, DataListTagRunsData, DataListTagRunsErrors, DataListTagRunsResponses, DataListTagsData, DataListTagsResponses, DataListTranslationsData, DataListTranslationsErrors, DataListTranslationsResponses, DataLookupPostsRouteData, DataLookupPostsRouteErrors, DataLookupPostsRouteResponses, DataMigrateBotCredentialsData, DataMigrateBotCredentialsErrors, DataMigrateBotCredentialsResponses, DataPlanSummaryPublicationData, DataPlanSummaryPublicationErrors, DataPlanSummaryPublicationResponses, DataPostsChainData, DataPostsChainErrors, DataPostsChainResponses, DataPostsCountsData, DataPostsCountsErrors, DataPostsCountsResponses, DataPostsFacetsData, DataPostsFacetsErrors, DataPostsFacetsResponses, DataPostsValueHistogramData, DataPostsValueHistogramErrors, DataPostsValueHistogramResponses, DataPostsViewEstimateData, DataPostsViewEstimateResponses, DataPostsWindowHistogramData, DataPostsWindowHistogramErrors, DataPostsWindowHistogramResponses, DataProjectDirectoryRefreshData, DataProjectDirectoryRefreshErrors, DataProjectDirectoryRefreshResponses, DataPurgeLogsData, DataPurgeLogsErrors, DataPurgeLogsResponses, DataPutDirectoryColumnsData, DataPutDirectoryColumnsErrors, DataPutDirectoryColumnsResponses, DataPutNetworkSettingsData, DataPutNetworkSettingsErrors, DataPutNetworkSettingsResponses, DataPutSettingData, DataPutSettingErrors, DataPutSettingResponses, DataReadTagOrderData, DataReadTagOrderErrors, DataReadTagOrderResponses, DataRecheckDiscoverProbesData, DataRecheckDiscoverProbesErrors, DataRecheckDiscoverProbesResponses, DataRecordSummaryFailureData, DataRecordSummaryFailureErrors, DataRecordSummaryFailureResponses, DataRecordTagUseData, DataRecordTagUseErrors, DataRecordTagUseResponses, DataRefreshDiscoverProbesData, DataRefreshDiscoverProbesErrors, DataRefreshDiscoverProbesResponses, DataRemoveDiscoverIgnoredData, DataRemoveDiscoverIgnoredErrors, DataRemoveDiscoverIgnoredResponses, DataRemoveTagChannelsData, DataRemoveTagChannelsErrors, DataRemoveTagChannelsResponses, DataRenameTagData, DataRenameTagErrors, DataRenameTagResponses, DataRestoreSummaryPartialData, DataRestoreSummaryPartialErrors, DataRestoreSummaryPartialResponses, DataSendSummaryPublicationData, DataSendSummaryPublicationErrors, DataSendSummaryPublicationResponses, DataSetDirectoryRefreshTargetData, DataSetDirectoryRefreshTargetErrors, DataSetDirectoryRefreshTargetResponses, DataStartBulkFollowData, DataStartBulkFollowErrors, DataStartBulkFollowResponses, DataStartSummaryAttemptData, DataStartSummaryAttemptErrors, DataStartSummaryAttemptResponses, DataStopSummaryAttemptData, DataStopSummaryAttemptErrors, DataStopSummaryAttemptResponses, DataSubmitChatSessionData, DataSubmitChatSessionErrors, DataSubmitChatSessionResponses, DataSubmitSummaryData, DataSubmitSummaryErrors, DataSubmitSummaryResponses, DataSubmitTagRunData, DataSubmitTagRunErrors, DataSubmitTagRunResponses, DataSummaryAttemptEventsData, DataSummaryAttemptEventsErrors, DataSummaryAttemptEventsResponses, DataTableSizesData, DataTableSizesResponses, DataUpdateDiscoverReportFlagsData, DataUpdateDiscoverReportFlagsErrors, DataUpdateDiscoverReportFlagsResponses, DataUpdateSettingGroupData, DataUpdateSettingGroupErrors, DataUpdateSettingGroupResponses, DataUpsertAiCredentialData, DataUpsertAiCredentialErrors, DataUpsertAiCredentialResponses, DataUpsertBotCredentialData, DataUpsertBotCredentialErrors, DataUpsertBotCredentialResponses, DataUpsertChannelData, DataUpsertChannelErrors, DataUpsertChannelResponses, DataUpsertChatDestinationData, DataUpsertChatDestinationErrors, DataUpsertChatDestinationResponses, DataUpsertChatSessionData, DataUpsertChatSessionErrors, DataUpsertChatSessionResponses, DataUpsertEmbeddingsData, DataUpsertEmbeddingsErrors, DataUpsertEmbeddingsResponses, DataUpsertSummaryData, DataUpsertSummaryErrors, DataUpsertSummaryResponses, DataUpsertTagRunData, DataUpsertTagRunErrors, DataUpsertTagRunResponses, DataUpsertTranslationsData, DataUpsertTranslationsErrors, DataUpsertTranslationsResponses, DataWindowCheckData, DataWindowCheckErrors, DataWindowCheckEventsData, DataWindowCheckEventsResponses, DataWindowCheckResponses, JobsCancelSyncJobData, JobsCancelSyncJobErrors, JobsCancelSyncJobResponses, JobsDrainSyncLaneData, JobsDrainSyncLaneErrors, JobsDrainSyncLaneResponses, JobsGetRuntimeConfigData, JobsGetRuntimeConfigResponses, JobsGetSyncJobStatusData, JobsGetSyncJobStatusErrors, JobsGetSyncJobStatusResponses, JobsJobsStatusData, JobsJobsStatusResponses, JobsListSyncLanesData, JobsListSyncLanesResponses, JobsPauseSyncLaneData, JobsPauseSyncLaneErrors, JobsPauseSyncLaneResponses, JobsResumeSyncLaneData, JobsResumeSyncLaneErrors, JobsResumeSyncLaneResponses, JobsStartSyncJobData, JobsStartSyncJobErrors, JobsStartSyncJobResponses, JobsSyncJobEventsData, JobsSyncJobEventsErrors, JobsSyncJobEventsResponses, JobsTriggerSchedulerJobData, JobsTriggerSchedulerJobErrors, JobsTriggerSchedulerJobResponses, JobsUpdateSchedulerJobData, JobsUpdateSchedulerJobErrors, JobsUpdateSchedulerJobResponses, LoginLoginAccessTokenData, LoginLoginAccessTokenErrors, LoginLoginAccessTokenResponses, LoginRecoverPasswordData, LoginRecoverPasswordErrors, LoginRecoverPasswordHtmlContentData, LoginRecoverPasswordHtmlContentErrors, LoginRecoverPasswordHtmlContentResponses, LoginRecoverPasswordResponses, LoginResetPasswordData, LoginResetPasswordErrors, LoginResetPasswordResponses, LoginTestTokenData, LoginTestTokenResponses, NetworkApiProxyHealthData, NetworkApiProxyHealthResponses, NetworkApiTestProxyData, NetworkApiTestProxyErrors, NetworkApiTestProxyResponses, NetworkApiTorIpData, NetworkApiTorIpResponses, NetworkApiTorNewIdentityData, NetworkApiTorNewIdentityErrors, NetworkApiTorNewIdentityResponses, NetworkApiTorRestartData, NetworkApiTorRestartResponses, NetworkApiTorStatusData, NetworkApiTorStatusResponses, QuotaLiftQuotaCeilingData, QuotaLiftQuotaCeilingErrors, QuotaLiftQuotaCeilingResponses, QuotaReadMyQuotaData, QuotaReadMyQuotaResponses, QuotaReadQuotaLimitsData, QuotaReadQuotaLimitsResponses, QuotaReadQuotaUsageData, QuotaReadQuotaUsageErrors, QuotaReadQuotaUsageResponses, QuotaSetQuotaDefaultsData, QuotaSetQuotaDefaultsErrors, QuotaSetQuotaDefaultsResponses, QuotaSetQuotaLimitsForUserData, QuotaSetQuotaLimitsForUserErrors, QuotaSetQuotaLimitsForUserResponses, RagRagEmbedData, RagRagEmbedErrors, RagRagEmbedResponses, RagRagSearchData, RagRagSearchErrors, RagRagSearchResponses, RagRagStatusData, RagRagStatusResponses, RequestsReadRequestBreakdownData, RequestsReadRequestBreakdownErrors, RequestsReadRequestBreakdownResponses, RequestsReadRequestRecordsData, RequestsReadRequestRecordsErrors, RequestsReadRequestRecordsResponses, RequestsReadRequestSpreadData, RequestsReadRequestSpreadErrors, RequestsReadRequestSpreadResponses, RequestsReadRequestTrendData, RequestsReadRequestTrendErrors, RequestsReadRequestTrendResponses, SettingsReadSettingsRegistryData, SettingsReadSettingsRegistryResponses, SettingsUpdateSettingData, SettingsUpdateSettingErrors, SettingsUpdateSettingResponses, TelegramApiBotFileData, TelegramApiBotFileErrors, TelegramApiBotFileResponses, TelegramApiBotInfoData, TelegramApiBotInfoErrors, TelegramApiBotInfoResponses, TelegramApiChannelInfoData, TelegramApiChannelInfoErrors, TelegramApiChannelInfoResponses, TelegramApiChannelPhotoData, TelegramApiChannelPhotoErrors, TelegramApiChannelPhotoResponses, TelegramApiPostThumbData, TelegramApiPostThumbErrors, TelegramApiPostThumbResponses, TelegramApiPublishData, TelegramApiPublishErrors, TelegramApiPublishResponses, TelegramApiResolveStartTimeData, TelegramApiResolveStartTimeErrors, TelegramApiResolveStartTimeResponses, TelegramApiScrapeData, TelegramApiScrapeErrors, TelegramApiScrapeResponses, UsersCreateUserData, UsersCreateUserErrors, UsersCreateUserResponses, UsersDeleteUserData, UsersDeleteUserErrors, UsersDeleteUserMeData, UsersDeleteUserMeResponses, UsersDeleteUserResponses, UsersReadUserByIdData, UsersReadUserByIdErrors, UsersReadUserByIdResponses, UsersReadUserMeData, UsersReadUserMeResponses, UsersReadUsersData, UsersReadUsersErrors, UsersReadUsersResponses, UsersRegisterUserData, UsersRegisterUserErrors, UsersRegisterUserResponses, UsersUpdatePasswordMeData, UsersUpdatePasswordMeErrors, UsersUpdatePasswordMeResponses, UsersUpdateUserData, UsersUpdateUserErrors, UsersUpdateUserMeData, UsersUpdateUserMeErrors, UsersUpdateUserMeResponses, UsersUpdateUserResponses, UtilsHealthCheckData, UtilsHealthCheckResponses, UtilsServerTimeData, UtilsServerTimeResponses, UtilsTestEmailData, UtilsTestEmailErrors, UtilsTestEmailResponses, ViewAsElevateViewAsData, ViewAsElevateViewAsErrors, ViewAsElevateViewAsResponses, ViewAsReadViewAsSessionsData, ViewAsReadViewAsSessionsErrors, ViewAsReadViewAsSessionsResponses, ViewAsSpendViewAsData, ViewAsSpendViewAsErrors, ViewAsSpendViewAsResponses, ViewAsStartViewAsData, ViewAsStartViewAsErrors, ViewAsStartViewAsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Login Access Token
 *
 * OAuth2 compatible token login, get an access token for future requests
 */
export const loginLoginAccessToken = <ThrowOnError extends boolean = true>(options: Options<LoginLoginAccessTokenData, ThrowOnError>): RequestResult<LoginLoginAccessTokenResponses, LoginLoginAccessTokenErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LoginLoginAccessTokenResponses, LoginLoginAccessTokenErrors, ThrowOnError, 'data'>({
    ...urlSearchParamsBodySerializer,
    responseStyle: 'data',
    url: '/api/v1/login/access-token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Test Token
 *
 * Test access token
 */
export const loginTestToken = <ThrowOnError extends boolean = true>(options?: Options<LoginTestTokenData, ThrowOnError>): RequestResult<LoginTestTokenResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<LoginTestTokenResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/login/test-token',
    ...options
});

/**
 * Recover Password
 *
 * Request a password reset link.
 */
export const loginRecoverPassword = <ThrowOnError extends boolean = true>(options: Options<LoginRecoverPasswordData, ThrowOnError>): RequestResult<LoginRecoverPasswordResponses, LoginRecoverPasswordErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LoginRecoverPasswordResponses, LoginRecoverPasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/password-recovery/{email}',
    ...options
});

/**
 * Reset Password
 *
 * Reset password
 */
export const loginResetPassword = <ThrowOnError extends boolean = true>(options: Options<LoginResetPasswordData, ThrowOnError>): RequestResult<LoginResetPasswordResponses, LoginResetPasswordErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LoginResetPasswordResponses, LoginResetPasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/reset-password/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recover Password Html Content
 *
 * HTML Content for Password Recovery
 */
export const loginRecoverPasswordHtmlContent = <ThrowOnError extends boolean = true>(options: Options<LoginRecoverPasswordHtmlContentData, ThrowOnError>): RequestResult<LoginRecoverPasswordHtmlContentResponses, LoginRecoverPasswordHtmlContentErrors, ThrowOnError, 'data'> => (options.client ?? client).post<LoginRecoverPasswordHtmlContentResponses, LoginRecoverPasswordHtmlContentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/password-recovery-html-content/{email}',
    ...options
});

/**
 * Read Users
 *
 * Retrieve users.
 */
export const usersReadUsers = <ThrowOnError extends boolean = true>(options?: Options<UsersReadUsersData, ThrowOnError>): RequestResult<UsersReadUsersResponses, UsersReadUsersErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<UsersReadUsersResponses, UsersReadUsersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/',
    ...options
});

/**
 * Create User
 *
 * Create new user.
 */
export const usersCreateUser = <ThrowOnError extends boolean = true>(options: Options<UsersCreateUserData, ThrowOnError>): RequestResult<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User Me
 *
 * Delete own user.
 */
export const usersDeleteUserMe = <ThrowOnError extends boolean = true>(options?: Options<UsersDeleteUserMeData, ThrowOnError>): RequestResult<UsersDeleteUserMeResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).delete<UsersDeleteUserMeResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options
});

/**
 * Read User Me
 *
 * Get current user.
 */
export const usersReadUserMe = <ThrowOnError extends boolean = true>(options?: Options<UsersReadUserMeData, ThrowOnError>): RequestResult<UsersReadUserMeResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<UsersReadUserMeResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options
});

/**
 * Update User Me
 *
 * Update own user.
 */
export const usersUpdateUserMe = <ThrowOnError extends boolean = true>(options: Options<UsersUpdateUserMeData, ThrowOnError>): RequestResult<UsersUpdateUserMeResponses, UsersUpdateUserMeErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<UsersUpdateUserMeResponses, UsersUpdateUserMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Password Me
 *
 * Update own password.
 */
export const usersUpdatePasswordMe = <ThrowOnError extends boolean = true>(options: Options<UsersUpdatePasswordMeData, ThrowOnError>): RequestResult<UsersUpdatePasswordMeResponses, UsersUpdatePasswordMeErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<UsersUpdatePasswordMeResponses, UsersUpdatePasswordMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register User
 *
 * Create new user without the need to be logged in.
 */
export const usersRegisterUser = <ThrowOnError extends boolean = true>(options: Options<UsersRegisterUserData, ThrowOnError>): RequestResult<UsersRegisterUserResponses, UsersRegisterUserErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UsersRegisterUserResponses, UsersRegisterUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/users/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User
 *
 * Delete a user.
 */
export const usersDeleteUser = <ThrowOnError extends boolean = true>(options: Options<UsersDeleteUserData, ThrowOnError>): RequestResult<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options
});

/**
 * Read User By Id
 *
 * Get a specific user by id.
 */
export const usersReadUserById = <ThrowOnError extends boolean = true>(options: Options<UsersReadUserByIdData, ThrowOnError>): RequestResult<UsersReadUserByIdResponses, UsersReadUserByIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<UsersReadUserByIdResponses, UsersReadUserByIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options
});

/**
 * Update User
 *
 * Update a user.
 */
export const usersUpdateUser = <ThrowOnError extends boolean = true>(options: Options<UsersUpdateUserData, ThrowOnError>): RequestResult<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test Email
 *
 * Test emails.
 */
export const utilsTestEmail = <ThrowOnError extends boolean = true>(options: Options<UtilsTestEmailData, ThrowOnError>): RequestResult<UtilsTestEmailResponses, UtilsTestEmailErrors, ThrowOnError, 'data'> => (options.client ?? client).post<UtilsTestEmailResponses, UtilsTestEmailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/utils/test-email/',
    ...options
});

/**
 * Health Check
 */
export const utilsHealthCheck = <ThrowOnError extends boolean = true>(options?: Options<UtilsHealthCheckData, ThrowOnError>): RequestResult<UtilsHealthCheckResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<UtilsHealthCheckResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/api/v1/utils/health-check/',
    ...options
});

/**
 * Server Time
 *
 * The server's current time, for a client estimating its clock offset.
 */
export const utilsServerTime = <ThrowOnError extends boolean = true>(options?: Options<UtilsServerTimeData, ThrowOnError>): RequestResult<UtilsServerTimeResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<UtilsServerTimeResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/utils/server-time',
    ...options
});

/**
 * Api Test Proxy
 */
export const networkApiTestProxy = <ThrowOnError extends boolean = true>(options: Options<NetworkApiTestProxyData, ThrowOnError>): RequestResult<NetworkApiTestProxyResponses, NetworkApiTestProxyErrors, ThrowOnError, 'data'> => (options.client ?? client).post<NetworkApiTestProxyResponses, NetworkApiTestProxyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/network/test-proxy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Proxy Health
 */
export const networkApiProxyHealth = <ThrowOnError extends boolean = true>(options?: Options<NetworkApiProxyHealthData, ThrowOnError>): RequestResult<NetworkApiProxyHealthResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<NetworkApiProxyHealthResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/network/proxy-health',
    ...options
});

/**
 * Api Tor Status
 */
export const networkApiTorStatus = <ThrowOnError extends boolean = true>(options?: Options<NetworkApiTorStatusData, ThrowOnError>): RequestResult<NetworkApiTorStatusResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<NetworkApiTorStatusResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/network/tor-status',
    ...options
});

/**
 * Api Tor Ip
 */
export const networkApiTorIp = <ThrowOnError extends boolean = true>(options?: Options<NetworkApiTorIpData, ThrowOnError>): RequestResult<NetworkApiTorIpResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<NetworkApiTorIpResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/network/tor-ip',
    ...options
});

/**
 * Api Tor Restart
 */
export const networkApiTorRestart = <ThrowOnError extends boolean = true>(options?: Options<NetworkApiTorRestartData, ThrowOnError>): RequestResult<NetworkApiTorRestartResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).post<NetworkApiTorRestartResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/network/tor-restart',
    ...options
});

/**
 * Api Tor New Identity
 */
export const networkApiTorNewIdentity = <ThrowOnError extends boolean = true>(options: Options<NetworkApiTorNewIdentityData, ThrowOnError>): RequestResult<NetworkApiTorNewIdentityResponses, NetworkApiTorNewIdentityErrors, ThrowOnError, 'data'> => (options.client ?? client).post<NetworkApiTorNewIdentityResponses, NetworkApiTorNewIdentityErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/network/tor-new-identity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Scrape
 */
export const telegramApiScrape = <ThrowOnError extends boolean = true>(options: Options<TelegramApiScrapeData, ThrowOnError>): RequestResult<TelegramApiScrapeResponses, TelegramApiScrapeErrors, ThrowOnError, 'data'> => (options.client ?? client).post<TelegramApiScrapeResponses, TelegramApiScrapeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/telegram/scrape',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Channel Info
 */
export const telegramApiChannelInfo = <ThrowOnError extends boolean = true>(options: Options<TelegramApiChannelInfoData, ThrowOnError>): RequestResult<TelegramApiChannelInfoResponses, TelegramApiChannelInfoErrors, ThrowOnError, 'data'> => (options.client ?? client).post<TelegramApiChannelInfoResponses, TelegramApiChannelInfoErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/telegram/channel-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Resolve Start Time
 */
export const telegramApiResolveStartTime = <ThrowOnError extends boolean = true>(options: Options<TelegramApiResolveStartTimeData, ThrowOnError>): RequestResult<TelegramApiResolveStartTimeResponses, TelegramApiResolveStartTimeErrors, ThrowOnError, 'data'> => (options.client ?? client).post<TelegramApiResolveStartTimeResponses, TelegramApiResolveStartTimeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/telegram/resolve-start-time',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Bot Info
 */
export const telegramApiBotInfo = <ThrowOnError extends boolean = true>(options: Options<TelegramApiBotInfoData, ThrowOnError>): RequestResult<TelegramApiBotInfoResponses, TelegramApiBotInfoErrors, ThrowOnError, 'data'> => (options.client ?? client).post<TelegramApiBotInfoResponses, TelegramApiBotInfoErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/telegram/bot-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Publish
 */
export const telegramApiPublish = <ThrowOnError extends boolean = true>(options: Options<TelegramApiPublishData, ThrowOnError>): RequestResult<TelegramApiPublishResponses, TelegramApiPublishErrors, ThrowOnError, 'data'> => (options.client ?? client).post<TelegramApiPublishResponses, TelegramApiPublishErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/telegram/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Channel Photo
 */
export const telegramApiChannelPhoto = <ThrowOnError extends boolean = true>(options: Options<TelegramApiChannelPhotoData, ThrowOnError>): RequestResult<TelegramApiChannelPhotoResponses, TelegramApiChannelPhotoErrors, ThrowOnError, 'data'> => (options.client ?? client).get<TelegramApiChannelPhotoResponses, TelegramApiChannelPhotoErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/telegram/channel-photo/{channel_id}',
    ...options
});

/**
 * Api Post Thumb
 */
export const telegramApiPostThumb = <ThrowOnError extends boolean = true>(options: Options<TelegramApiPostThumbData, ThrowOnError>): RequestResult<TelegramApiPostThumbResponses, TelegramApiPostThumbErrors, ThrowOnError, 'data'> => (options.client ?? client).get<TelegramApiPostThumbResponses, TelegramApiPostThumbErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/telegram/post-thumb/{channel_name}/{post_id}',
    ...options
});

/**
 * Api Bot File
 */
export const telegramApiBotFile = <ThrowOnError extends boolean = true>(options: Options<TelegramApiBotFileData, ThrowOnError>): RequestResult<TelegramApiBotFileResponses, TelegramApiBotFileErrors, ThrowOnError, 'data'> => (options.client ?? client).get<TelegramApiBotFileResponses, TelegramApiBotFileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/telegram/bot-file/{credential_id}',
    ...options
});

/**
 * Api List Models
 *
 * List the models the chosen AI key's provider offers.
 */
export const aiApiListModels = <ThrowOnError extends boolean = true>(options: Options<AiApiListModelsData, ThrowOnError>): RequestResult<AiApiListModelsResponses, AiApiListModelsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AiApiListModelsResponses, AiApiListModelsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai/models',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Summary Prompt
 */
export const aiApiSummaryPrompt = <ThrowOnError extends boolean = true>(options: Options<AiApiSummaryPromptData, ThrowOnError>): RequestResult<AiApiSummaryPromptResponses, AiApiSummaryPromptErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AiApiSummaryPromptResponses, AiApiSummaryPromptErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai/summary/prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Chat Stream
 */
export const aiApiChatStream = <ThrowOnError extends boolean = true>(options: Options<AiApiChatStreamData, ThrowOnError>): RequestResult<AiApiChatStreamResponses, AiApiChatStreamErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AiApiChatStreamResponses, AiApiChatStreamErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai/chat/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Tag Prompt
 */
export const aiApiTagPrompt = <ThrowOnError extends boolean = true>(options: Options<AiApiTagPromptData, ThrowOnError>): RequestResult<AiApiTagPromptResponses, AiApiTagPromptErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AiApiTagPromptResponses, AiApiTagPromptErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai/tag/prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Tag Stream
 */
export const aiApiTagStream = <ThrowOnError extends boolean = true>(options: Options<AiApiTagStreamData, ThrowOnError>): RequestResult<AiApiTagStreamResponses, AiApiTagStreamErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AiApiTagStreamResponses, AiApiTagStreamErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai/tag/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Embeddings
 */
export const aiApiEmbeddings = <ThrowOnError extends boolean = true>(options: Options<AiApiEmbeddingsData, ThrowOnError>): RequestResult<AiApiEmbeddingsResponses, AiApiEmbeddingsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AiApiEmbeddingsResponses, AiApiEmbeddingsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai/embeddings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Api Translate
 */
export const aiApiTranslate = <ThrowOnError extends boolean = true>(options: Options<AiApiTranslateData, ThrowOnError>): RequestResult<AiApiTranslateResponses, AiApiTranslateErrors, ThrowOnError, 'data'> => (options.client ?? client).post<AiApiTranslateResponses, AiApiTranslateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai/translate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Sync Meta Route
 */
export const dataGetSyncMetaRoute = <ThrowOnError extends boolean = true>(options?: Options<DataGetSyncMetaRouteData, ThrowOnError>): RequestResult<DataGetSyncMetaRouteResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataGetSyncMetaRouteResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/sync-meta',
    ...options
});

/**
 * List Channels
 *
 * The channel list, without `bio` — see `list_channel_bios`.
 *
 * Returns a hand-built `Response` so the body can be hashed into an `ETag`;
 * `response_model` above still drives the OpenAPI schema and the generated
 * client. `refetchOnWindowFocus` asks for this list on every window focus, and
 * channel rows are quiet minute to minute (0 changed in the last minute, 1 in
 * five, on staging), so most of those become a bodiless 304 instead of 494 KB.
 */
export const dataListChannels = <ThrowOnError extends boolean = true>(options?: Options<DataListChannelsData, ThrowOnError>): RequestResult<DataListChannelsResponses, DataListChannelsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListChannelsResponses, DataListChannelsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels',
    ...options
});

/**
 * List Channel Stats
 *
 * Post aggregates for every channel, keyed by channel name.
 *
 * The Channels tab's stats, split off `GET /channels?includeStats=true` so the
 * grid can paint without them: they cost 2.36s of a 3.13s response and 46 KB of
 * a 536 KB payload, and only two of the grid's eleven sort options read them.
 *
 * Declared ahead of every `/channels/{channel_id}` route so a literal "stats"
 * can never be captured as a channel id — the same ordering hazard the
 * `/discover/reports/latest` and `/settings/network` routes are placed against.
 */
export const dataListChannelStats = <ThrowOnError extends boolean = true>(options?: Options<DataListChannelStatsData, ThrowOnError>): RequestResult<DataListChannelStatsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListChannelStatsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/stats',
    ...options
});

/**
 * List Channel Bios
 *
 * Every channel's bio, keyed by channel name.
 *
 * 40% of the channel list's gzipped bytes for something the grid clamps to two
 * lines on the ~20 cards on screen. Off the critical path here, the grid paints
 * from a 297 KB list instead of a 494 KB one.
 *
 * Same ordering placement as `/channels/stats`: ahead of `/channels/{id}`.
 */
export const dataListChannelBios = <ThrowOnError extends boolean = true>(options?: Options<DataListChannelBiosData, ThrowOnError>): RequestResult<DataListChannelBiosResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListChannelBiosResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bios',
    ...options
});

/**
 * Delete Channel
 *
 * Remove the channel from the caller's list. Its posts are left alone.
 */
export const dataDeleteChannel = <ThrowOnError extends boolean = true>(options: Options<DataDeleteChannelData, ThrowOnError>): RequestResult<DataDeleteChannelResponses, DataDeleteChannelErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteChannelResponses, DataDeleteChannelErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/{channel_id}',
    ...options
});

/**
 * Upsert Channel
 *
 * Edit a Channel, or follow one that already exists.
 *
 * A `PUT` from an account that does not follow this Channel yet creates the
 * follow; the Channel itself is shared corpus and is not re-created.
 */
export const dataUpsertChannel = <ThrowOnError extends boolean = true>(options: Options<DataUpsertChannelData, ThrowOnError>): RequestResult<DataUpsertChannelResponses, DataUpsertChannelErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpsertChannelResponses, DataUpsertChannelErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/{channel_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Bulk Follow
 */
export const dataStartBulkFollow = <ThrowOnError extends boolean = true>(options: Options<DataStartBulkFollowData, ThrowOnError>): RequestResult<DataStartBulkFollowResponses, DataStartBulkFollowErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataStartBulkFollowResponses, DataStartBulkFollowErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-follow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Bulk Follow Status
 */
export const dataGetBulkFollowStatus = <ThrowOnError extends boolean = true>(options: Options<DataGetBulkFollowStatusData, ThrowOnError>): RequestResult<DataGetBulkFollowStatusResponses, DataGetBulkFollowStatusErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetBulkFollowStatusResponses, DataGetBulkFollowStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-follow/{follow_job_id}',
    ...options
});

/**
 * Bulk Follow Events
 */
export const dataBulkFollowEvents = <ThrowOnError extends boolean = true>(options: Options<DataBulkFollowEventsData, ThrowOnError>): RequestResult<DataBulkFollowEventsResponses, DataBulkFollowEventsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataBulkFollowEventsResponses, DataBulkFollowEventsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-follow/{follow_job_id}/events',
    ...options
});

/**
 * Cancel Bulk Follow
 */
export const dataCancelBulkFollow = <ThrowOnError extends boolean = true>(options: Options<DataCancelBulkFollowData, ThrowOnError>): RequestResult<DataCancelBulkFollowResponses, DataCancelBulkFollowErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataCancelBulkFollowResponses, DataCancelBulkFollowErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-follow/{follow_job_id}/cancel',
    ...options
});

/**
 * Bulk Reresolve Start Ids Endpoint
 */
export const dataBulkReresolveStartIdsEndpoint = <ThrowOnError extends boolean = true>(options?: Options<DataBulkReresolveStartIdsEndpointData, ThrowOnError>): RequestResult<DataBulkReresolveStartIdsEndpointResponses, DataBulkReresolveStartIdsEndpointErrors, ThrowOnError, 'data'> => (options?.client ?? client).post<DataBulkReresolveStartIdsEndpointResponses, DataBulkReresolveStartIdsEndpointErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-reresolve-start-ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Bulk Reset Sync Endpoint
 */
export const dataBulkResetSyncEndpoint = <ThrowOnError extends boolean = true>(options: Options<DataBulkResetSyncEndpointData, ThrowOnError>): RequestResult<DataBulkResetSyncEndpointResponses, DataBulkResetSyncEndpointErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataBulkResetSyncEndpointResponses, DataBulkResetSyncEndpointErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-reset-sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Sync Settings Endpoint
 */
export const dataBulkSyncSettingsEndpoint = <ThrowOnError extends boolean = true>(options: Options<DataBulkSyncSettingsEndpointData, ThrowOnError>): RequestResult<DataBulkSyncSettingsEndpointResponses, DataBulkSyncSettingsEndpointErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<DataBulkSyncSettingsEndpointResponses, DataBulkSyncSettingsEndpointErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-sync-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Setting Groups
 */
export const dataListSettingGroups = <ThrowOnError extends boolean = true>(options?: Options<DataListSettingGroupsData, ThrowOnError>): RequestResult<DataListSettingGroupsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListSettingGroupsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/setting-groups',
    ...options
});

/**
 * Create Setting Group
 */
export const dataCreateSettingGroup = <ThrowOnError extends boolean = true>(options: Options<DataCreateSettingGroupData, ThrowOnError>): RequestResult<DataCreateSettingGroupResponses, DataCreateSettingGroupErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataCreateSettingGroupResponses, DataCreateSettingGroupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/setting-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Setting Group
 */
export const dataDeleteSettingGroup = <ThrowOnError extends boolean = true>(options: Options<DataDeleteSettingGroupData, ThrowOnError>): RequestResult<DataDeleteSettingGroupResponses, DataDeleteSettingGroupErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteSettingGroupResponses, DataDeleteSettingGroupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/setting-groups/{group_id}',
    ...options
});

/**
 * Update Setting Group
 */
export const dataUpdateSettingGroup = <ThrowOnError extends boolean = true>(options: Options<DataUpdateSettingGroupData, ThrowOnError>): RequestResult<DataUpdateSettingGroupResponses, DataUpdateSettingGroupErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpdateSettingGroupResponses, DataUpdateSettingGroupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/setting-groups/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Assign Setting Group
 */
export const dataBulkAssignSettingGroup = <ThrowOnError extends boolean = true>(options: Options<DataBulkAssignSettingGroupData, ThrowOnError>): RequestResult<DataBulkAssignSettingGroupResponses, DataBulkAssignSettingGroupErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<DataBulkAssignSettingGroupResponses, DataBulkAssignSettingGroupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-setting-group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Channel Tags Endpoint
 */
export const dataBulkChannelTagsEndpoint = <ThrowOnError extends boolean = true>(options: Options<DataBulkChannelTagsEndpointData, ThrowOnError>): RequestResult<DataBulkChannelTagsEndpointResponses, DataBulkChannelTagsEndpointErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<DataBulkChannelTagsEndpointResponses, DataBulkChannelTagsEndpointErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/bulk-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Channel Stats
 */
export const dataGetChannelStats = <ThrowOnError extends boolean = true>(options: Options<DataGetChannelStatsData, ThrowOnError>): RequestResult<DataGetChannelStatsResponses, DataGetChannelStatsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetChannelStatsResponses, DataGetChannelStatsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/channels/{channel_id}/stats',
    ...options
});

/**
 * List Posts
 *
 * One page of posts for a channel/date scope.
 *
 * With no filter, no cap and ``sort=newest`` this is the newest-first page the
 * export/lookup fallbacks and language detection rely on. The Posts feed also
 * passes the keyword, the Post filter, a per-channel cap, a sort order and
 * ``offset`` so the whole view is assembled server-side instead of paging a
 * channel's history into the browser.
 *
 * POST rather than GET because the scope carries the channel selection, which
 * can be the entire account — see `PostScopeRequest`. This is a read expressed
 * as a POST purely so the selection travels in the body.
 *
 * Each post says whether the Post selection selects it. ``selectedFirst``
 * lists the selected Posts before the rest, and ``onlySelected`` returns only
 * the selected Posts the filter shows.
 */
export const dataListPosts = <ThrowOnError extends boolean = true>(options: Options<DataListPostsData, ThrowOnError>): RequestResult<DataListPostsResponses, DataListPostsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataListPostsResponses, DataListPostsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Posts Counts
 *
 * Per-channel post counts for a filtered scope, computed as a SQL GROUP BY.
 *
 * Replaces the client's `buildPostsInScopeCounts`, which counted the fully
 * fetched, client-filtered post array. Also says how many Posts an Estimated
 * views bound hid for being too new to judge, how many Posts in the window
 * the Post selection selects, filters aside, and how many of the Posts the
 * filter shows it selects.
 *
 * POST rather than GET because the scope carries the channel selection: this is
 * a read expressed as a POST purely so the selection travels in the body.
 */
export const dataPostsCounts = <ThrowOnError extends boolean = true>(options: Options<DataPostsCountsData, ThrowOnError>): RequestResult<DataPostsCountsResponses, DataPostsCountsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataPostsCountsResponses, DataPostsCountsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/counts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Posts Value Histogram
 *
 * One measure's bars over the window and the Channels.
 *
 * What a number filter's editor draws: 32 bars from the lowest value to the
 * highest, logarithmic when the highest is over 100 times the lowest.
 * `views` and `estimated` count Posts, `channel_posts` and
 * `channel_posts_filtered` count Channels by their Posts in the window. The
 * Post filter and the keyword in the body are applied only by
 * `channel_posts_filtered`, whose count is the Posts they keep, so the
 * other bars hold still while the Account changes another Condition.
 */
export const dataPostsValueHistogram = <ThrowOnError extends boolean = true>(options: Options<DataPostsValueHistogramData, ThrowOnError>): RequestResult<DataPostsValueHistogramResponses, DataPostsValueHistogramErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataPostsValueHistogramResponses, DataPostsValueHistogramErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/value-histogram',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Posts Window Histogram
 *
 * How many Posts fall in each equal slice of a stretch of time.
 *
 * What the Analysis window editor's chart draws. Filtered, the Post filter
 * and keyword apply but the per-Channel cap does not, so the bars do not
 * depend on the feed's order; `unfiltered` counts every Post of the
 * selected Channels. A Channel posts Condition counts within the Analysis
 * window, not the stretch drawn.
 */
export const dataPostsWindowHistogram = <ThrowOnError extends boolean = true>(options: Options<DataPostsWindowHistogramData, ThrowOnError>): RequestResult<DataPostsWindowHistogramResponses, DataPostsWindowHistogramErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataPostsWindowHistogramResponses, DataPostsWindowHistogramErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/window-histogram',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Posts View Estimate
 *
 * The Settling curve and settings an Estimated View count is read through.
 */
export const dataPostsViewEstimate = <ThrowOnError extends boolean = true>(options?: Options<DataPostsViewEstimateData, ThrowOnError>): RequestResult<DataPostsViewEstimateResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataPostsViewEstimateResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/view-estimate',
    ...options
});

/**
 * Posts Facets
 *
 * How many Posts in the window have each Type, media kind and Language.
 *
 * And how many of each value the Post selection selects.
 */
export const dataPostsFacets = <ThrowOnError extends boolean = true>(options: Options<DataPostsFacetsData, ThrowOnError>): RequestResult<DataPostsFacetsResponses, DataPostsFacetsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataPostsFacetsResponses, DataPostsFacetsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/facets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lookup Posts Route
 */
export const dataLookupPostsRoute = <ThrowOnError extends boolean = true>(options: Options<DataLookupPostsRouteData, ThrowOnError>): RequestResult<DataLookupPostsRouteResponses, DataLookupPostsRouteErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataLookupPostsRouteResponses, DataLookupPostsRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/lookup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Posts Chain
 *
 * A reply's Reply chain up to the top in one read, and why it ends there.
 *
 * The starting Post first, each flagged by the Post selection under the
 * sent window and Channels. 404 when the Account cannot see the starting
 * Post.
 */
export const dataPostsChain = <ThrowOnError extends boolean = true>(options: Options<DataPostsChainData, ThrowOnError>): RequestResult<DataPostsChainResponses, DataPostsChainErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataPostsChainResponses, DataPostsChainErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/chain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Window Check
 *
 * Which of these Channels the workspace can prove it holds every Post of,
 * from the window's Start to its End or now, whichever is earlier, and why
 * not. Reads what is held and which syncs are still running; never syncs.
 */
export const dataWindowCheck = <ThrowOnError extends boolean = true>(options: Options<DataWindowCheckData, ThrowOnError>): RequestResult<DataWindowCheckResponses, DataWindowCheckErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataWindowCheckResponses, DataWindowCheckErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/window-check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Window Check Events
 *
 * Server-sent events: the names of followed Channels a sync just changed,
 * gathered per second, so the page asks the window check for those alone.
 * The first frame names none and says the stream is open.
 */
export const dataWindowCheckEvents = <ThrowOnError extends boolean = true>(options?: Options<DataWindowCheckEventsData, ThrowOnError>): RequestResult<DataWindowCheckEventsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataWindowCheckEventsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/window-check/events',
    ...options
});

/**
 * Bulk Upsert Posts Route
 */
export const dataBulkUpsertPostsRoute = <ThrowOnError extends boolean = true>(options: Options<DataBulkUpsertPostsRouteData, ThrowOnError>): RequestResult<DataBulkUpsertPostsRouteResponses, DataBulkUpsertPostsRouteErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataBulkUpsertPostsRouteResponses, DataBulkUpsertPostsRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/posts/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Discover Candidates
 *
 * Aggregated discovery candidates for a channel/date scope.
 *
 * Returns counts only. The client previously fetched every post body in
 * scope to compute this in JS. A report covers the Post selection, which the
 * server resolves here like every other Action's.
 *
 * POST rather than GET for the same reason as `/posts` — the channel selection
 * travels in the body so it cannot overflow the request line.
 */
export const dataDiscoverCandidates = <ThrowOnError extends boolean = true>(options: Options<DataDiscoverCandidatesData, ThrowOnError>): RequestResult<DataDiscoverCandidatesResponses, DataDiscoverCandidatesErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataDiscoverCandidatesResponses, DataDiscoverCandidatesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/candidates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Discover Ignored
 *
 * Undo a dismissal.
 *
 * DELETE with a body rather than a path param so a batch can be undone in one
 * call, matching the POST.
 */
export const dataRemoveDiscoverIgnored = <ThrowOnError extends boolean = true>(options: Options<DataRemoveDiscoverIgnoredData, ThrowOnError>): RequestResult<DataRemoveDiscoverIgnoredResponses, DataRemoveDiscoverIgnoredErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataRemoveDiscoverIgnoredResponses, DataRemoveDiscoverIgnoredErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/ignored',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Discover Ignored
 *
 * Dismissed candidates, newest first.
 */
export const dataListDiscoverIgnored = <ThrowOnError extends boolean = true>(options?: Options<DataListDiscoverIgnoredData, ThrowOnError>): RequestResult<DataListDiscoverIgnoredResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListDiscoverIgnoredResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/ignored',
    ...options
});

/**
 * Add Discover Ignored
 *
 * Dismiss candidates so later reports stop re-surfacing them.
 *
 * Idempotent: re-dismissing an entry is a no-op rather than an error, since
 * the UI treats this as a toggle.
 */
export const dataAddDiscoverIgnored = <ThrowOnError extends boolean = true>(options: Options<DataAddDiscoverIgnoredData, ThrowOnError>): RequestResult<DataAddDiscoverIgnoredResponses, DataAddDiscoverIgnoredErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataAddDiscoverIgnoredResponses, DataAddDiscoverIgnoredErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/ignored',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Discover Probes
 *
 * One page of cached handle probes, optionally filtered by status.
 */
export const dataListDiscoverProbes = <ThrowOnError extends boolean = true>(options?: Options<DataListDiscoverProbesData, ThrowOnError>): RequestResult<DataListDiscoverProbesResponses, DataListDiscoverProbesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListDiscoverProbesResponses, DataListDiscoverProbesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/probes',
    ...options
});

/**
 * Get Discover Probe Queue
 *
 * Probe queue state, for the progress display.
 *
 * There is no job id to poll: probing is a scheduled backend job draining a
 * durable queue (`app.jobs.discover_probe`), not something a client starts.
 * Everything the UI needs is a count, and the verdicts themselves arrive
 * through the report read, which already joins the probe table.
 *
 * `enabled` reflects the operator's pause switch — the ordinary job toggle, so
 * pausing is durable and every open tab agrees about it.
 *
 * The response carries what the lane has *spent* beside what it has left to do. The
 * counts alone say nothing about cost, and the harvest sweep means handles now
 * arrive without anybody asking for them — so an Operator watching a queue
 * drain has no way to tell a healthy crawl from a runaway one until Telegram
 * says so. Deployment-wide numbers with no owner: these are a tally, not a
 * quota, and reading them charges nobody.
 */
export const dataGetDiscoverProbeQueue = <ThrowOnError extends boolean = true>(options?: Options<DataGetDiscoverProbeQueueData, ThrowOnError>): RequestResult<DataGetDiscoverProbeQueueResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataGetDiscoverProbeQueueResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/probe/queue',
    ...options
});

/**
 * Recheck Discover Probes
 *
 * Discard cached verdicts for these handles and put them back in the queue.
 *
 * The escape hatch for a verdict that is wrong or has gone stale: a private
 * channel that opened up, or a handle misjudged during an outage. Without it,
 * caching indefinitely would mean a single bad answer is permanent.
 *
 * Requeues at the front rather than merely forgetting. A row is both the cached
 * answer and the work item, so deleting it would drop the handle out of the
 * queue and nothing would fetch it again. The next drain tick picks these up
 * first, so the wait is bounded by the job interval.
 */
export const dataRecheckDiscoverProbes = <ThrowOnError extends boolean = true>(options: Options<DataRecheckDiscoverProbesData, ThrowOnError>): RequestResult<DataRecheckDiscoverProbesResponses, DataRecheckDiscoverProbesErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataRecheckDiscoverProbesResponses, DataRecheckDiscoverProbesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/probe/recheck',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Discover Probes
 *
 * Mark these Directory entries due now, keeping the answers they hold.
 *
 * The on-demand half of the refresh window: an Operator deciding whether to
 * follow a Candidate should not be reading week-old data, and the window that
 * paces the crawl is measured in days.
 *
 * Not a recheck. A recheck says the verdict is *wrong* and discards it, so the
 * row goes blank until the queue reaches it; this says the answer is *old*, so
 * the entry goes on rendering what it has while the fresh fetch is queued at
 * the front. A dead verdict is refreshed too when it is asked for by name —
 * never automatically due is not never due, and a channel that went private
 * and came back is exactly what this is pressed on.
 */
export const dataRefreshDiscoverProbes = <ThrowOnError extends boolean = true>(options: Options<DataRefreshDiscoverProbesData, ThrowOnError>): RequestResult<DataRefreshDiscoverProbesResponses, DataRefreshDiscoverProbesErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataRefreshDiscoverProbesResponses, DataRefreshDiscoverProbesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/probe/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Discover Reports
 *
 * Newest-first page of saved reports, without their candidate rows.
 *
 * See `report_to_camel_light`: a wide-scope report holds the full
 * single-reference tail, so the list ships a `candidateCount` instead.
 */
export const dataListDiscoverReports = <ThrowOnError extends boolean = true>(options?: Options<DataListDiscoverReportsData, ThrowOnError>): RequestResult<DataListDiscoverReportsResponses, DataListDiscoverReportsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListDiscoverReportsResponses, DataListDiscoverReportsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/reports',
    ...options
});

/**
 * Create Discover Report
 *
 * Generate a Discover report and save it.
 *
 * Unlike `/discover/candidates`, which computes and forgets, this persists the
 * result together with a snapshot of the scope it was generated for. The saved
 * report is immutable: later changes to the channel selection or the Posts-tab
 * filters produce a *new* report rather than altering this one (IDEA-011 W1).
 */
export const dataCreateDiscoverReport = <ThrowOnError extends boolean = true>(options: Options<DataCreateDiscoverReportData, ThrowOnError>): RequestResult<DataCreateDiscoverReportResponses, DataCreateDiscoverReportErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataCreateDiscoverReportResponses, DataCreateDiscoverReportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Discover Report
 */
export const dataDeleteDiscoverReport = <ThrowOnError extends boolean = true>(options: Options<DataDeleteDiscoverReportData, ThrowOnError>): RequestResult<DataDeleteDiscoverReportResponses, DataDeleteDiscoverReportErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteDiscoverReportResponses, DataDeleteDiscoverReportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/reports/{report_id}',
    ...options
});

/**
 * Get Discover Report
 *
 * A saved report with every candidate, `isFollowed` resolved live.
 */
export const dataGetDiscoverReport = <ThrowOnError extends boolean = true>(options: Options<DataGetDiscoverReportData, ThrowOnError>): RequestResult<DataGetDiscoverReportResponses, DataGetDiscoverReportErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetDiscoverReportResponses, DataGetDiscoverReportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/reports/{report_id}',
    ...options
});

/**
 * Update Discover Report Flags
 *
 * Star or annotate a saved report — the only write it accepts.
 */
export const dataUpdateDiscoverReportFlags = <ThrowOnError extends boolean = true>(options: Options<DataUpdateDiscoverReportFlagsData, ThrowOnError>): RequestResult<DataUpdateDiscoverReportFlagsResponses, DataUpdateDiscoverReportFlagsErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpdateDiscoverReportFlagsResponses, DataUpdateDiscoverReportFlagsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/discover/reports/{report_id}/flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Directory Posts
 *
 * The Channel's recent Posts, as the last probe captured them.
 *
 * What a Channel actually publishes, read without leaving the app and without
 * reaching Telegram. **This issues no fetch**: it serves the snapshot the
 * probe already stored, because a user-facing trigger on a rate-limited
 * scraper would let a click jump the queue that exists to decide ordering. A
 * stale answer is refreshed through `POST /discover/probe/refresh`, which goes
 * through that queue.
 *
 * Empty is a real answer and means the entry has no recent Posts — an
 * `unavailable` verdict clears the snapshot outright, and retention collects
 * it on the sample window. The 404 is the other absence: the deployment holds
 * nothing about this handle, no verdict and no Posts.
 */
export const dataGetDirectoryPosts = <ThrowOnError extends boolean = true>(options: Options<DataGetDirectoryPostsData, ThrowOnError>): RequestResult<DataGetDirectoryPostsResponses, DataGetDirectoryPostsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetDirectoryPostsResponses, DataGetDirectoryPostsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/{handle}/posts',
    ...options
});

/**
 * List Directory
 *
 * One page of 100 Directory entries under a Directory filter, sorted.
 *
 * With the view's total, its Language counts and its Bio language counts,
 * each menu's counted without that menu's own Conditions.
 */
export const dataListDirectory = <ThrowOnError extends boolean = true>(options: Options<DataListDirectoryData, ThrowOnError>): RequestResult<DataListDirectoryResponses, DataListDirectoryErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataListDirectoryResponses, DataListDirectoryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Count Directory
 *
 * How many entries a view leaves, with a candidate Condition added with AND.
 */
export const dataCountDirectory = <ThrowOnError extends boolean = true>(options: Options<DataCountDirectoryData, ThrowOnError>): RequestResult<DataCountDirectoryResponses, DataCountDirectoryErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataCountDirectoryResponses, DataCountDirectoryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/count',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Directory Handles
 *
 * Every handle a view matches, in the list's sort, to tick them all.
 */
export const dataListDirectoryHandles = <ThrowOnError extends boolean = true>(options: Options<DataListDirectoryHandlesData, ThrowOnError>): RequestResult<DataListDirectoryHandlesResponses, DataListDirectoryHandlesErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataListDirectoryHandlesResponses, DataListDirectoryHandlesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/handles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Directory Distribution
 *
 * A measure's spread across the view with its own bounds left out.
 */
export const dataGetDirectoryDistribution = <ThrowOnError extends boolean = true>(options: Options<DataGetDirectoryDistributionData, ThrowOnError>): RequestResult<DataGetDirectoryDistributionResponses, DataGetDirectoryDistributionErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataGetDirectoryDistributionResponses, DataGetDirectoryDistributionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/distribution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Directory Size
 *
 * How many entries the Directory lists to this reader at all.
 */
export const dataGetDirectorySize = <ThrowOnError extends boolean = true>(options?: Options<DataGetDirectorySizeData, ThrowOnError>): RequestResult<DataGetDirectorySizeResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataGetDirectorySizeResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/size',
    ...options
});

/**
 * List Directory Columns
 *
 * The Directory columns this caller may show, in table order, each with
 * whether it is on by default.
 */
export const dataListDirectoryColumns = <ThrowOnError extends boolean = true>(options?: Options<DataListDirectoryColumnsData, ThrowOnError>): RequestResult<DataListDirectoryColumnsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListDirectoryColumnsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/columns',
    ...options
});

/**
 * Put Directory Columns
 *
 * Set which Directory columns are on by default for every Account; a
 * column not named is off.
 */
export const dataPutDirectoryColumns = <ThrowOnError extends boolean = true>(options: Options<DataPutDirectoryColumnsData, ThrowOnError>): RequestResult<DataPutDirectoryColumnsResponses, DataPutDirectoryColumnsErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataPutDirectoryColumnsResponses, DataPutDirectoryColumnsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/columns',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Boost Directory
 *
 * Set the Priority boost of the named Directory entries, or add to it.
 *
 * A positive boost fetches an entry sooner. A handle the Directory holds
 * nothing about is skipped; an add that carries any entry out of range
 * changes none.
 */
export const dataBoostDirectory = <ThrowOnError extends boolean = true>(options: Options<DataBoostDirectoryData, ThrowOnError>): RequestResult<DataBoostDirectoryResponses, DataBoostDirectoryErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataBoostDirectoryResponses, DataBoostDirectoryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/boost',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Directory Refresh Target
 *
 * Set the Refresh target of the named Directory entries, or clear it.
 *
 * Their due dates move at once, still within the deployment's shortest and
 * longest waits. A handle the Directory holds nothing about is skipped.
 */
export const dataSetDirectoryRefreshTarget = <ThrowOnError extends boolean = true>(options: Options<DataSetDirectoryRefreshTargetData, ThrowOnError>): RequestResult<DataSetDirectoryRefreshTargetResponses, DataSetDirectoryRefreshTargetErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataSetDirectoryRefreshTargetResponses, DataSetDirectoryRefreshTargetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/refresh-target',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Project Directory Refresh
 *
 * Refreshes a day these values would cost, and what probing fetched.
 *
 * Reads every live entry, so the Settings page asks as values change and
 * never on load.
 */
export const dataProjectDirectoryRefresh = <ThrowOnError extends boolean = true>(options: Options<DataProjectDirectoryRefreshData, ThrowOnError>): RequestResult<DataProjectDirectoryRefreshResponses, DataProjectDirectoryRefreshErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataProjectDirectoryRefreshResponses, DataProjectDirectoryRefreshErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/refresh-projection',
    ...options
});

/**
 * Add Directory Handles
 *
 * Queue pasted handles for a fetch, without following any of them.
 */
export const dataAddDirectoryHandles = <ThrowOnError extends boolean = true>(options: Options<DataAddDirectoryHandlesData, ThrowOnError>): RequestResult<DataAddDirectoryHandlesResponses, DataAddDirectoryHandlesErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataAddDirectoryHandlesResponses, DataAddDirectoryHandlesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/add',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Directory Entry
 *
 * One listed Directory entry by handle, with its bio, for the detail panel.
 */
export const dataGetDirectoryEntry = <ThrowOnError extends boolean = true>(options: Options<DataGetDirectoryEntryData, ThrowOnError>): RequestResult<DataGetDirectoryEntryResponses, DataGetDirectoryEntryErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetDirectoryEntryResponses, DataGetDirectoryEntryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/{handle}/entry',
    ...options
});

/**
 * Get Directory Neighbours
 *
 * The Channels citing a Channel most, and those it cites most.
 */
export const dataGetDirectoryNeighbours = <ThrowOnError extends boolean = true>(options: Options<DataGetDirectoryNeighboursData, ThrowOnError>): RequestResult<DataGetDirectoryNeighboursResponses, DataGetDirectoryNeighboursErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetDirectoryNeighboursResponses, DataGetDirectoryNeighboursErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/{handle}/neighbours',
    ...options
});

/**
 * Get Directory Why
 *
 * The Posts of "your channels" that cite a Channel, newest first.
 */
export const dataGetDirectoryWhy = <ThrowOnError extends boolean = true>(options: Options<DataGetDirectoryWhyData, ThrowOnError>): RequestResult<DataGetDirectoryWhyResponses, DataGetDirectoryWhyErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataGetDirectoryWhyResponses, DataGetDirectoryWhyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/directory/why',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Tag
 *
 * Take a Tag off every Channel.
 */
export const dataDeleteTag = <ThrowOnError extends boolean = true>(options: Options<DataDeleteTagData, ThrowOnError>): RequestResult<DataDeleteTagResponses, DataDeleteTagErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteTagResponses, DataDeleteTagErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tags
 *
 * The caller's Tags with how many Channels carry each, by name.
 */
export const dataListTags = <ThrowOnError extends boolean = true>(options?: Options<DataListTagsData, ThrowOnError>): RequestResult<DataListTagsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListTagsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tags',
    ...options
});

/**
 * Rename Tag
 *
 * Rename a Tag on every Channel; onto a name the caller has, the two merge.
 */
export const dataRenameTag = <ThrowOnError extends boolean = true>(options: Options<DataRenameTagData, ThrowOnError>): RequestResult<DataRenameTagResponses, DataRenameTagErrors, ThrowOnError, 'data'> => (options.client ?? client).patch<DataRenameTagResponses, DataRenameTagErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Tag Channels
 *
 * Take a Tag off handles. A body rather than a path, matching the POST.
 */
export const dataRemoveTagChannels = <ThrowOnError extends boolean = true>(options: Options<DataRemoveTagChannelsData, ThrowOnError>): RequestResult<DataRemoveTagChannelsResponses, DataRemoveTagChannelsErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataRemoveTagChannelsResponses, DataRemoveTagChannelsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tags/channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tag Channels
 *
 * The handles carrying one of the caller's Tags; a `group:` name included.
 */
export const dataListTagChannels = <ThrowOnError extends boolean = true>(options: Options<DataListTagChannelsData, ThrowOnError>): RequestResult<DataListTagChannelsResponses, DataListTagChannelsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataListTagChannelsResponses, DataListTagChannelsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tags/channels',
    ...options
});

/**
 * Add Tag Channels
 *
 * Put a Tag on handles, followed or not; a new name makes a new Tag.
 */
export const dataAddTagChannels = <ThrowOnError extends boolean = true>(options: Options<DataAddTagChannelsData, ThrowOnError>): RequestResult<DataAddTagChannelsResponses, DataAddTagChannelsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataAddTagChannelsResponses, DataAddTagChannelsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tags/channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Tag Use
 *
 * Record one use of a Tag on a tab; nothing for a Tag the caller lacks.
 */
export const dataRecordTagUse = <ThrowOnError extends boolean = true>(options: Options<DataRecordTagUseData, ThrowOnError>): RequestResult<DataRecordTagUseResponses, DataRecordTagUseErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataRecordTagUseResponses, DataRecordTagUseErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tags/uses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Tag Order
 *
 * Each of the caller's Tags by name: its channels in the scope, how many
 * of those are selected, and its Tag use score and last use on the tab.
 */
export const dataReadTagOrder = <ThrowOnError extends boolean = true>(options: Options<DataReadTagOrderData, ThrowOnError>): RequestResult<DataReadTagOrderResponses, DataReadTagOrderErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataReadTagOrderResponses, DataReadTagOrderErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tags/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Summaries
 *
 * List in the light projection — see `summary_to_camel_light`.
 *
 * `search` matches channels/text/promptText/model/note in SQL, so prompt
 * bodies stay searchable without being shipped to the client.
 */
export const dataListSummaries = <ThrowOnError extends boolean = true>(options?: Options<DataListSummariesData, ThrowOnError>): RequestResult<DataListSummariesResponses, DataListSummariesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListSummariesResponses, DataListSummariesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries',
    ...options
});

/**
 * Submit Summary
 *
 * Open a summary at a frozen Scope, before any AI work begins.
 */
export const dataSubmitSummary = <ThrowOnError extends boolean = true>(options: Options<DataSubmitSummaryData, ThrowOnError>): RequestResult<DataSubmitSummaryResponses, DataSubmitSummaryErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataSubmitSummaryResponses, DataSubmitSummaryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Summary
 */
export const dataDeleteSummary = <ThrowOnError extends boolean = true>(options: Options<DataDeleteSummaryData, ThrowOnError>): RequestResult<DataDeleteSummaryResponses, DataDeleteSummaryErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteSummaryResponses, DataDeleteSummaryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}',
    ...options
});

/**
 * Get Summary
 *
 * Full summary including citedPosts/promptText/chatMessages.
 */
export const dataGetSummary = <ThrowOnError extends boolean = true>(options: Options<DataGetSummaryData, ThrowOnError>): RequestResult<DataGetSummaryResponses, DataGetSummaryErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetSummaryResponses, DataGetSummaryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}',
    ...options
});

/**
 * Upsert Summary
 */
export const dataUpsertSummary = <ThrowOnError extends boolean = true>(options: Options<DataUpsertSummaryData, ThrowOnError>): RequestResult<DataUpsertSummaryResponses, DataUpsertSummaryErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpsertSummaryResponses, DataUpsertSummaryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Summary Attempts
 *
 * Every attempt to generate this summary, oldest first.
 */
export const dataListSummaryAttempts = <ThrowOnError extends boolean = true>(options: Options<DataListSummaryAttemptsData, ThrowOnError>): RequestResult<DataListSummaryAttemptsResponses, DataListSummaryAttemptsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataListSummaryAttemptsResponses, DataListSummaryAttemptsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/attempts',
    ...options
});

/**
 * Record Summary Failure
 *
 * Record a generation that failed before it started; the summary becomes failed.
 */
export const dataRecordSummaryFailure = <ThrowOnError extends boolean = true>(options: Options<DataRecordSummaryFailureData, ThrowOnError>): RequestResult<DataRecordSummaryFailureResponses, DataRecordSummaryFailureErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataRecordSummaryFailureResponses, DataRecordSummaryFailureErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/failures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Summary Attempt
 *
 * Start generating this summary on the worker; watch it with the events stream.
 */
export const dataStartSummaryAttempt = <ThrowOnError extends boolean = true>(options: Options<DataStartSummaryAttemptData, ThrowOnError>): RequestResult<DataStartSummaryAttemptResponses, DataStartSummaryAttemptErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataStartSummaryAttemptResponses, DataStartSummaryAttemptErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/attempts/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop Summary Attempt
 *
 * Stop a running attempt; the text it produced is kept on the attempt.
 */
export const dataStopSummaryAttempt = <ThrowOnError extends boolean = true>(options: Options<DataStopSummaryAttemptData, ThrowOnError>): RequestResult<DataStopSummaryAttemptResponses, DataStopSummaryAttemptErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataStopSummaryAttemptResponses, DataStopSummaryAttemptErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/attempts/{attempt_id}/stop',
    ...options
});

/**
 * Cancel Summary Attempt
 *
 * Withdraw an attempt that is still waiting to start, such as an automatic retry.
 */
export const dataCancelSummaryAttempt = <ThrowOnError extends boolean = true>(options: Options<DataCancelSummaryAttemptData, ThrowOnError>): RequestResult<DataCancelSummaryAttemptResponses, DataCancelSummaryAttemptErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataCancelSummaryAttemptResponses, DataCancelSummaryAttemptErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/attempts/{attempt_id}/cancel',
    ...options
});

/**
 * Keep Summary Partial
 *
 * Finish the summary with this attempt's partial response; it becomes Cut short.
 */
export const dataKeepSummaryPartial = <ThrowOnError extends boolean = true>(options: Options<DataKeepSummaryPartialData, ThrowOnError>): RequestResult<DataKeepSummaryPartialResponses, DataKeepSummaryPartialErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataKeepSummaryPartialResponses, DataKeepSummaryPartialErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/attempts/{attempt_id}/keep',
    ...options
});

/**
 * Dismiss Summary Partial
 *
 * Set this attempt's partial response aside; its text is kept.
 */
export const dataDismissSummaryPartial = <ThrowOnError extends boolean = true>(options: Options<DataDismissSummaryPartialData, ThrowOnError>): RequestResult<DataDismissSummaryPartialResponses, DataDismissSummaryPartialErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataDismissSummaryPartialResponses, DataDismissSummaryPartialErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/attempts/{attempt_id}/dismiss',
    ...options
});

/**
 * Restore Summary Partial
 *
 * Bring back a dismissed partial response.
 */
export const dataRestoreSummaryPartial = <ThrowOnError extends boolean = true>(options: Options<DataRestoreSummaryPartialData, ThrowOnError>): RequestResult<DataRestoreSummaryPartialResponses, DataRestoreSummaryPartialErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataRestoreSummaryPartialResponses, DataRestoreSummaryPartialErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/attempts/{attempt_id}/restore',
    ...options
});

/**
 * Summary Attempt Events
 *
 * Server-sent events: the attempt's text as it arrives, then how it ended.
 */
export const dataSummaryAttemptEvents = <ThrowOnError extends boolean = true>(options: Options<DataSummaryAttemptEventsData, ThrowOnError>): RequestResult<DataSummaryAttemptEventsResponses, DataSummaryAttemptEventsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataSummaryAttemptEventsResponses, DataSummaryAttemptEventsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/attempts/{attempt_id}/events',
    ...options
});

/**
 * List Tag Runs
 *
 * List runs in the light projection — see `tag_run_to_camel_light`.
 */
export const dataListTagRuns = <ThrowOnError extends boolean = true>(options?: Options<DataListTagRunsData, ThrowOnError>): RequestResult<DataListTagRunsResponses, DataListTagRunsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListTagRunsResponses, DataListTagRunsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tag-runs',
    ...options
});

/**
 * Submit Tag Run
 *
 * Open a tag run at a frozen Scope, before the prompt is assembled.
 */
export const dataSubmitTagRun = <ThrowOnError extends boolean = true>(options: Options<DataSubmitTagRunData, ThrowOnError>): RequestResult<DataSubmitTagRunResponses, DataSubmitTagRunErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataSubmitTagRunResponses, DataSubmitTagRunErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tag-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Tag Run
 */
export const dataDeleteTagRun = <ThrowOnError extends boolean = true>(options: Options<DataDeleteTagRunData, ThrowOnError>): RequestResult<DataDeleteTagRunResponses, DataDeleteTagRunErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteTagRunResponses, DataDeleteTagRunErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tag-runs/{tag_run_id}',
    ...options
});

/**
 * Get Tag Run
 *
 * Full run including promptText/responseText/suggestions.
 */
export const dataGetTagRun = <ThrowOnError extends boolean = true>(options: Options<DataGetTagRunData, ThrowOnError>): RequestResult<DataGetTagRunResponses, DataGetTagRunErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetTagRunResponses, DataGetTagRunErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tag-runs/{tag_run_id}',
    ...options
});

/**
 * Upsert Tag Run
 */
export const dataUpsertTagRun = <ThrowOnError extends boolean = true>(options: Options<DataUpsertTagRunData, ThrowOnError>): RequestResult<DataUpsertTagRunResponses, DataUpsertTagRunErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpsertTagRunResponses, DataUpsertTagRunErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tag-runs/{tag_run_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Plan Summary Publication
 *
 * The Parts a Publication of this Summary would send, and its default metadata.
 */
export const dataPlanSummaryPublication = <ThrowOnError extends boolean = true>(options: Options<DataPlanSummaryPublicationData, ThrowOnError>): RequestResult<DataPlanSummaryPublicationResponses, DataPlanSummaryPublicationErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataPlanSummaryPublicationResponses, DataPlanSummaryPublicationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/publication/plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Summary Publication
 *
 * Plan this Summary's Publication and send exactly those Parts.
 *
 * Given `publicationId`, finish that partial Publication instead: only its
 * remaining stored Parts, to the bot and chat it started with.
 */
export const dataSendSummaryPublication = <ThrowOnError extends boolean = true>(options: Options<DataSendSummaryPublicationData, ThrowOnError>): RequestResult<DataSendSummaryPublicationResponses, DataSendSummaryPublicationErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataSendSummaryPublicationResponses, DataSendSummaryPublicationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/summaries/{summary_id}/publication',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Chat Sessions
 *
 * List in the light projection — see `chat_session_to_camel_light`.
 *
 * `search` matches title/channels/model/note in SQL. It does not reach the
 * transcript; the title already carries the first user message.
 */
export const dataListChatSessions = <ThrowOnError extends boolean = true>(options?: Options<DataListChatSessionsData, ThrowOnError>): RequestResult<DataListChatSessionsResponses, DataListChatSessionsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListChatSessionsResponses, DataListChatSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/chat-sessions',
    ...options
});

/**
 * Submit Chat Session
 *
 * Open a chat at a frozen Scope, before any AI work begins.
 */
export const dataSubmitChatSession = <ThrowOnError extends boolean = true>(options: Options<DataSubmitChatSessionData, ThrowOnError>): RequestResult<DataSubmitChatSessionResponses, DataSubmitChatSessionErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataSubmitChatSessionResponses, DataSubmitChatSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/chat-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Chat Session
 */
export const dataDeleteChatSession = <ThrowOnError extends boolean = true>(options: Options<DataDeleteChatSessionData, ThrowOnError>): RequestResult<DataDeleteChatSessionResponses, DataDeleteChatSessionErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteChatSessionResponses, DataDeleteChatSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/chat-sessions/{chat_session_id}',
    ...options
});

/**
 * Get Chat Session
 *
 * Full chat session including the transcript.
 */
export const dataGetChatSession = <ThrowOnError extends boolean = true>(options: Options<DataGetChatSessionData, ThrowOnError>): RequestResult<DataGetChatSessionResponses, DataGetChatSessionErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetChatSessionResponses, DataGetChatSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/chat-sessions/{chat_session_id}',
    ...options
});

/**
 * Upsert Chat Session
 */
export const dataUpsertChatSession = <ThrowOnError extends boolean = true>(options: Options<DataUpsertChatSessionData, ThrowOnError>): RequestResult<DataUpsertChatSessionResponses, DataUpsertChatSessionErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpsertChatSessionResponses, DataUpsertChatSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/chat-sessions/{chat_session_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Artifacts
 *
 * One page of every saved artifact, whatever its kind, newest Written first.
 *
 * A `UNION ALL` over four tables projecting **named columns only**. It must not
 * open `tg_summary_payloads` or `tg_chat_session_payloads`, and must not select
 * the corpus-sized columns of `tg_tag_runs` / `tg_discover_reports` — pinned by
 * `tests/services/test_artifact_list_payload_cost.py`.
 *
 * `search` deliberately does not reach summary prompt bodies; that would mean
 * opening a payload table. `/data/summaries?search=` still does.
 *
 * `mode`, `start` and `end` bound `moment`: when an artifact was Written,
 * `[start, end)`, or its Analysis window, which matches when it overlaps the
 * bound. `sort` is Written or the window's start; a missing window sorts last
 * either way.
 */
export const dataListArtifacts = <ThrowOnError extends boolean = true>(options?: Options<DataListArtifactsData, ThrowOnError>): RequestResult<DataListArtifactsResponses, DataListArtifactsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListArtifactsResponses, DataListArtifactsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/artifacts',
    ...options
});

/**
 * Count Artifacts Route
 *
 * The list's total, and how many each Kind and Status choice would show.
 *
 * Each Kind is counted under every filter but Kind, each Status under every
 * filter but Status, and the total under all of them.
 */
export const dataCountArtifactsRoute = <ThrowOnError extends boolean = true>(options?: Options<DataCountArtifactsRouteData, ThrowOnError>): RequestResult<DataCountArtifactsRouteResponses, DataCountArtifactsRouteErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataCountArtifactsRouteResponses, DataCountArtifactsRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/artifacts/counts',
    ...options
});

/**
 * Get Artifact Spread Route
 *
 * When artifacts were Written, or their windows started: 32 bars over epoch ms.
 *
 * Under every filter but the Time bound, so the editor shows what lies around
 * it. Under `window`, an artifact with no window is left out. A zoom (`lo`,
 * `hi`) bins only that range; `total`, `min`, `max` and `median` stay the
 * whole spread's.
 */
export const dataGetArtifactSpreadRoute = <ThrowOnError extends boolean = true>(options?: Options<DataGetArtifactSpreadRouteData, ThrowOnError>): RequestResult<DataGetArtifactSpreadRouteResponses, DataGetArtifactSpreadRouteErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataGetArtifactSpreadRouteResponses, DataGetArtifactSpreadRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/artifacts/spread',
    ...options
});

/**
 * List Bot Credentials
 */
export const dataListBotCredentials = <ThrowOnError extends boolean = true>(options?: Options<DataListBotCredentialsData, ThrowOnError>): RequestResult<DataListBotCredentialsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListBotCredentialsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/bot-credentials',
    ...options
});

/**
 * Delete Bot Credential
 */
export const dataDeleteBotCredential = <ThrowOnError extends boolean = true>(options: Options<DataDeleteBotCredentialData, ThrowOnError>): RequestResult<DataDeleteBotCredentialResponses, DataDeleteBotCredentialErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteBotCredentialResponses, DataDeleteBotCredentialErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/bot-credentials/{bot_id}',
    ...options
});

/**
 * Upsert Bot Credential
 */
export const dataUpsertBotCredential = <ThrowOnError extends boolean = true>(options: Options<DataUpsertBotCredentialData, ThrowOnError>): RequestResult<DataUpsertBotCredentialResponses, DataUpsertBotCredentialErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpsertBotCredentialResponses, DataUpsertBotCredentialErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/bot-credentials/{bot_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Migrate Bot Credentials
 */
export const dataMigrateBotCredentials = <ThrowOnError extends boolean = true>(options: Options<DataMigrateBotCredentialsData, ThrowOnError>): RequestResult<DataMigrateBotCredentialsResponses, DataMigrateBotCredentialsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataMigrateBotCredentialsResponses, DataMigrateBotCredentialsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/bot-credentials/migrate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Chat Destinations
 */
export const dataListChatDestinations = <ThrowOnError extends boolean = true>(options?: Options<DataListChatDestinationsData, ThrowOnError>): RequestResult<DataListChatDestinationsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListChatDestinationsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/chat-destinations',
    ...options
});

/**
 * Delete Chat Destination
 */
export const dataDeleteChatDestination = <ThrowOnError extends boolean = true>(options: Options<DataDeleteChatDestinationData, ThrowOnError>): RequestResult<DataDeleteChatDestinationResponses, DataDeleteChatDestinationErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteChatDestinationResponses, DataDeleteChatDestinationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/chat-destinations/{dest_id}',
    ...options
});

/**
 * Upsert Chat Destination
 */
export const dataUpsertChatDestination = <ThrowOnError extends boolean = true>(options: Options<DataUpsertChatDestinationData, ThrowOnError>): RequestResult<DataUpsertChatDestinationResponses, DataUpsertChatDestinationErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpsertChatDestinationResponses, DataUpsertChatDestinationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/chat-destinations/{dest_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Ai Credentials
 */
export const dataListAiCredentials = <ThrowOnError extends boolean = true>(options?: Options<DataListAiCredentialsData, ThrowOnError>): RequestResult<DataListAiCredentialsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListAiCredentialsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/ai-keys',
    ...options
});

/**
 * Delete Ai Credential
 */
export const dataDeleteAiCredential = <ThrowOnError extends boolean = true>(options: Options<DataDeleteAiCredentialData, ThrowOnError>): RequestResult<DataDeleteAiCredentialResponses, DataDeleteAiCredentialErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataDeleteAiCredentialResponses, DataDeleteAiCredentialErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/ai-keys/{key_id}',
    ...options
});

/**
 * Upsert Ai Credential
 *
 * Save an AI key and validate it against its provider.
 */
export const dataUpsertAiCredential = <ThrowOnError extends boolean = true>(options: Options<DataUpsertAiCredentialData, ThrowOnError>): RequestResult<DataUpsertAiCredentialResponses, DataUpsertAiCredentialErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataUpsertAiCredentialResponses, DataUpsertAiCredentialErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/ai-keys/{key_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert Embeddings
 */
export const dataUpsertEmbeddings = <ThrowOnError extends boolean = true>(options: Options<DataUpsertEmbeddingsData, ThrowOnError>): RequestResult<DataUpsertEmbeddingsResponses, DataUpsertEmbeddingsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataUpsertEmbeddingsResponses, DataUpsertEmbeddingsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/embeddings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Translation
 *
 * Read a single translation. Returns null when absent.
 */
export const dataGetTranslation = <ThrowOnError extends boolean = true>(options: Options<DataGetTranslationData, ThrowOnError>): RequestResult<DataGetTranslationResponses, DataGetTranslationErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetTranslationResponses, DataGetTranslationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/translations/one',
    ...options
});

/**
 * List Translations
 */
export const dataListTranslations = <ThrowOnError extends boolean = true>(options?: Options<DataListTranslationsData, ThrowOnError>): RequestResult<DataListTranslationsResponses, DataListTranslationsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataListTranslationsResponses, DataListTranslationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/translations',
    ...options
});

/**
 * Upsert Translations
 */
export const dataUpsertTranslations = <ThrowOnError extends boolean = true>(options: Options<DataUpsertTranslationsData, ThrowOnError>): RequestResult<DataUpsertTranslationsResponses, DataUpsertTranslationsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataUpsertTranslationsResponses, DataUpsertTranslationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Logs Route
 *
 * One newest-first page of any log type, without the corpus-sized fields.
 *
 * Paged rather than whole-table: these tables carry request/response JSON and
 * grow without bound between retention sweeps, so an unfiltered select can
 * materialise gigabytes and OOM the worker. Full data ships via the export
 * path, which streams.
 *
 * The bodies are on `GET /logs/{log_type}/{log_id}` — this page was 56.28 MB
 * for 500 rows, 99.7% of it bodies the viewer only renders for an expanded
 * row. `search` runs in SQL so they stay findable without being sent, and
 * `searchInDetails` extends the match into them; both now search the whole
 * table rather than the page that happened to be fetched.
 *
 * `mode`, `start` and `end` bound when entries were logged, `[start, end)`
 * to the minute, either end open, applied before paging so the bound reaches
 * every entry of the log.
 */
export const dataListLogsRoute = <ThrowOnError extends boolean = true>(options: Options<DataListLogsRouteData, ThrowOnError>): RequestResult<DataListLogsRouteResponses, DataListLogsRouteErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataListLogsRouteResponses, DataListLogsRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/logs/{log_type}',
    ...options
});

/**
 * Create Logs Route
 *
 * Upsert a batch of log rows of one type.
 */
export const dataCreateLogsRoute = <ThrowOnError extends boolean = true>(options: Options<DataCreateLogsRouteData, ThrowOnError>): RequestResult<DataCreateLogsRouteResponses, DataCreateLogsRouteErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataCreateLogsRouteResponses, DataCreateLogsRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/logs/{log_type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Log Spread Route
 *
 * When a log's entries were logged: 32 bars over epoch ms.
 *
 * Under the text search and without the Logged bound, so the editor shows
 * what lies around it. A zoom (`lo`, `hi`) bins only that range; `total`,
 * `min`, `max` and `median` stay the whole spread's.
 */
export const dataGetLogSpreadRoute = <ThrowOnError extends boolean = true>(options: Options<DataGetLogSpreadRouteData, ThrowOnError>): RequestResult<DataGetLogSpreadRouteResponses, DataGetLogSpreadRouteErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetLogSpreadRouteResponses, DataGetLogSpreadRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/logs/{log_type}/spread',
    ...options
});

/**
 * Get Log Route
 *
 * One log row in full, bodies included.
 *
 * The other half of the list projection. `GET /data/logs/sync` shipped
 * 56.28 MB for a page of 500 rows, 99.7% of it request/response bodies that
 * the viewer renders only for an expanded row — and it expands one at a time.
 * This serves that one row.
 */
export const dataGetLogRoute = <ThrowOnError extends boolean = true>(options: Options<DataGetLogRouteData, ThrowOnError>): RequestResult<DataGetLogRouteResponses, DataGetLogRouteErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetLogRouteResponses, DataGetLogRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/logs/{log_type}/{log_id}',
    ...options
});

/**
 * Purge Logs
 *
 * Three deletes behind one endpoint, and they are not the same act.
 *
 * `olderThanDays` and `clearAll` sweep across every account, so both demand
 * `DATA_ADMIN`. `logId` removes exactly one row, which is what the delete
 * button on each of the five Logs tabs calls, for everybody — gating the whole
 * route turned that into an error toast for any non-Admin, so the gate is per
 * branch. The single-row branch answers to the owner instead.
 *
 * `SHARED_LOG_TYPES` is the exception, and it is derived from the tenancy
 * classification rather than listed here: for a type nobody owns a row of,
 * there is no owner for `get_log` to answer to, so the single-row delete is an
 * administrative act like the two sweeps. That covers sync logs and network
 * logs, which have been deletable one row at a time by any
 * authenticated account since the Admin gate went on their *reads* alone.
 */
export const dataPurgeLogs = <ThrowOnError extends boolean = true>(options?: Options<DataPurgeLogsData, ThrowOnError>): RequestResult<DataPurgeLogsResponses, DataPurgeLogsErrors, ThrowOnError, 'data'> => (options?.client ?? client).delete<DataPurgeLogsResponses, DataPurgeLogsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/logs',
    ...options
});

/**
 * Db Stats
 */
export const dataDbStats = <ThrowOnError extends boolean = true>(options?: Options<DataDbStatsData, ThrowOnError>): RequestResult<DataDbStatsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataDbStatsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/stats',
    ...options
});

/**
 * Table Sizes
 */
export const dataTableSizes = <ThrowOnError extends boolean = true>(options?: Options<DataTableSizesData, ThrowOnError>): RequestResult<DataTableSizesResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataTableSizesResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/table-sizes',
    ...options
});

/**
 * Clear Table Route
 */
export const dataClearTableRoute = <ThrowOnError extends boolean = true>(options: Options<DataClearTableRouteData, ThrowOnError>): RequestResult<DataClearTableRouteResponses, DataClearTableRouteErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<DataClearTableRouteResponses, DataClearTableRouteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/tables/{name}',
    ...options
});

/**
 * Get Network Settings
 */
export const dataGetNetworkSettings = <ThrowOnError extends boolean = true>(options?: Options<DataGetNetworkSettingsData, ThrowOnError>): RequestResult<DataGetNetworkSettingsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<DataGetNetworkSettingsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/settings/network',
    ...options
});

/**
 * Put Network Settings
 */
export const dataPutNetworkSettings = <ThrowOnError extends boolean = true>(options: Options<DataPutNetworkSettingsData, ThrowOnError>): RequestResult<DataPutNetworkSettingsResponses, DataPutNetworkSettingsErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataPutNetworkSettingsResponses, DataPutNetworkSettingsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/settings/network',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Setting
 */
export const dataGetSetting = <ThrowOnError extends boolean = true>(options: Options<DataGetSettingData, ThrowOnError>): RequestResult<DataGetSettingResponses, DataGetSettingErrors, ThrowOnError, 'data'> => (options.client ?? client).get<DataGetSettingResponses, DataGetSettingErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/settings/{key}',
    ...options
});

/**
 * Put Setting
 *
 * Write one settings section, refusing deployment policy to a non-Admin.
 *
 * The route stays open because the *key* decides, not the path. `jobs` turns
 * the scheduler off for everybody, and so on for every other global key:
 * those are `DATA_ADMIN`.
 *
 * `sync` and `retention` cannot be gated that way, because each is a facade:
 * one body carries deployment policy and the caller's own preferences at the
 * same time. `sync` mixes scheduler policy, the runtime counters the Pause
 * button writes, and a person's start-time defaults; `retention` mixes the
 * corpus window — `postRetentionDays`, which deletes every account's Posts on
 * the next sweep, table clearing on a timer — with that person's own log and
 * report windows. Refusing the whole request would take their own settings
 * away from them, so for a caller without the permission the body is narrowed
 * to the fields the registry declares personal and the rest is dropped rather
 * than written. Dropping, not refusing, because the frontend sends a whole
 * section at once and a non-Admin saving their preferences should not be told
 * the save failed when the half that is theirs succeeded.
 */
export const dataPutSetting = <ThrowOnError extends boolean = true>(options: Options<DataPutSettingData, ThrowOnError>): RequestResult<DataPutSettingResponses, DataPutSettingErrors, ThrowOnError, 'data'> => (options.client ?? client).put<DataPutSettingResponses, DataPutSettingErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/settings/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import Data
 *
 * Restore a document into one account's rows.
 *
 * `subject` is the account the document lands under, defaulting to the caller
 * — the same parameter the export takes, so a backup of one person restores
 * as that person instead of as whoever ran it. `all` is refused:
 * an import writes rows and a document carries no owners, so "everybody" has
 * no meaning here that is not "the caller", which is what leaving it off
 * already says.
 *
 * Importing *for* somebody is a write on their behalf, so the acting Owner is
 * bound for this session before anything is written and every artifact the
 * document restores records who really uploaded it.
 */
export const dataImportData = <ThrowOnError extends boolean = true>(options: Options<DataImportDataData, ThrowOnError>): RequestResult<DataImportDataResponses, DataImportDataErrors, ThrowOnError, 'data'> => (options.client ?? client).post<DataImportDataResponses, DataImportDataErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Data
 *
 * One account's export, or the whole deployment's — never truncated.
 *
 * `subject` is absent for the caller's own rows, a user id for that
 * account's, `all` for everybody's.
 *
 * Streamed rather than built in memory: the payload spans every post and log
 * row, which is far more than a worker can hold at once. The per-section row
 * counts are computed first and travel in `X-Export-Rows`, because a
 * `StreamingResponse` sends its headers before the generator runs — which is
 * what makes "reports the row count before starting" true for a client that
 * has not parsed a byte of the body yet. The same numbers lead the document,
 * from the same computation, so the header and the file cannot disagree.
 */
export const dataExportData = <ThrowOnError extends boolean = true>(options?: Options<DataExportDataData, ThrowOnError>): RequestResult<DataExportDataResponses, DataExportDataErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<DataExportDataResponses, DataExportDataErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/data/export',
    ...options
});

/**
 * Rag Status
 */
export const ragRagStatus = <ThrowOnError extends boolean = true>(options?: Options<RagRagStatusData, ThrowOnError>): RequestResult<RagRagStatusResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<RagRagStatusResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/rag/status',
    ...options
});

/**
 * Rag Embed
 */
export const ragRagEmbed = <ThrowOnError extends boolean = true>(options: Options<RagRagEmbedData, ThrowOnError>): RequestResult<RagRagEmbedResponses, RagRagEmbedErrors, ThrowOnError, 'data'> => (options.client ?? client).post<RagRagEmbedResponses, RagRagEmbedErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/rag/embed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rag Search
 */
export const ragRagSearch = <ThrowOnError extends boolean = true>(options: Options<RagRagSearchData, ThrowOnError>): RequestResult<RagRagSearchResponses, RagRagSearchErrors, ThrowOnError, 'data'> => (options.client ?? client).post<RagRagSearchResponses, RagRagSearchErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/rag/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Jobs Status
 */
export const jobsJobsStatus = <ThrowOnError extends boolean = true>(options?: Options<JobsJobsStatusData, ThrowOnError>): RequestResult<JobsJobsStatusResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<JobsJobsStatusResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/status',
    ...options
});

/**
 * Inspect resolved runtime diagnostics
 *
 * Return time-varying effective state that is not configuration inventory.
 *
 * Its clock, resolved cutoff/start time, proxy lanes and active job are
 * runtime diagnostics, not Settings or Configuration rows.
 */
export const jobsGetRuntimeConfig = <ThrowOnError extends boolean = true>(options?: Options<JobsGetRuntimeConfigData, ThrowOnError>): RequestResult<JobsGetRuntimeConfigResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<JobsGetRuntimeConfigResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/runtime-config',
    ...options
});

/**
 * Trigger Scheduler Job
 */
export const jobsTriggerSchedulerJob = <ThrowOnError extends boolean = true>(options: Options<JobsTriggerSchedulerJobData, ThrowOnError>): RequestResult<JobsTriggerSchedulerJobResponses, JobsTriggerSchedulerJobErrors, ThrowOnError, 'data'> => (options.client ?? client).post<JobsTriggerSchedulerJobResponses, JobsTriggerSchedulerJobErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/{job_id}/trigger',
    ...options
});

/**
 * Update Scheduler Job
 */
export const jobsUpdateSchedulerJob = <ThrowOnError extends boolean = true>(options: Options<JobsUpdateSchedulerJobData, ThrowOnError>): RequestResult<JobsUpdateSchedulerJobResponses, JobsUpdateSchedulerJobErrors, ThrowOnError, 'data'> => (options.client ?? client).put<JobsUpdateSchedulerJobResponses, JobsUpdateSchedulerJobErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/{job_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Sync Lanes
 *
 * Every lane, in drain order, with its depth and paused state.
 */
export const jobsListSyncLanes = <ThrowOnError extends boolean = true>(options?: Options<JobsListSyncLanesData, ThrowOnError>): RequestResult<JobsListSyncLanesResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<JobsListSyncLanesResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/lanes',
    ...options
});

/**
 * Pause Sync Lane
 *
 * Stop the worker taking new messages from this lane.
 *
 * Reversible and lossless: the messages stay queued and visible, and the next
 * drain after a resume picks them up. That is the difference from
 * `drain_sync_lane` below, which is neither.
 */
export const jobsPauseSyncLane = <ThrowOnError extends boolean = true>(options: Options<JobsPauseSyncLaneData, ThrowOnError>): RequestResult<JobsPauseSyncLaneResponses, JobsPauseSyncLaneErrors, ThrowOnError, 'data'> => (options.client ?? client).post<JobsPauseSyncLaneResponses, JobsPauseSyncLaneErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/lanes/{lane}/pause',
    ...options
});

/**
 * Resume Sync Lane
 */
export const jobsResumeSyncLane = <ThrowOnError extends boolean = true>(options: Options<JobsResumeSyncLaneData, ThrowOnError>): RequestResult<JobsResumeSyncLaneResponses, JobsResumeSyncLaneErrors, ThrowOnError, 'data'> => (options.client ?? client).post<JobsResumeSyncLaneResponses, JobsResumeSyncLaneErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/lanes/{lane}/resume',
    ...options
});

/**
 * Drain Sync Lane
 *
 * Empty this lane now: archive every message and cancel the jobs behind it.
 *
 * Destructive, and gated on `JOBS_MANAGE` for the reason that permission
 * already gives for covering `POST /{job_id}/trigger`: triggering retention
 * deletes Posts, so this permission is not a read-only one and pausing or
 * discarding queued work is the same audience and the same act.
 */
export const jobsDrainSyncLane = <ThrowOnError extends boolean = true>(options: Options<JobsDrainSyncLaneData, ThrowOnError>): RequestResult<JobsDrainSyncLaneResponses, JobsDrainSyncLaneErrors, ThrowOnError, 'data'> => (options.client ?? client).post<JobsDrainSyncLaneResponses, JobsDrainSyncLaneErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/lanes/{lane}/drain',
    ...options
});

/**
 * Start Sync Job
 */
export const jobsStartSyncJob = <ThrowOnError extends boolean = true>(options: Options<JobsStartSyncJobData, ThrowOnError>): RequestResult<JobsStartSyncJobResponses, JobsStartSyncJobErrors, ThrowOnError, 'data'> => (options.client ?? client).post<JobsStartSyncJobResponses, JobsStartSyncJobErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Sync Job Status
 */
export const jobsGetSyncJobStatus = <ThrowOnError extends boolean = true>(options: Options<JobsGetSyncJobStatusData, ThrowOnError>): RequestResult<JobsGetSyncJobStatusResponses, JobsGetSyncJobStatusErrors, ThrowOnError, 'data'> => (options.client ?? client).get<JobsGetSyncJobStatusResponses, JobsGetSyncJobStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/sync/{job_id}',
    ...options
});

/**
 * Sync Job Events
 */
export const jobsSyncJobEvents = <ThrowOnError extends boolean = true>(options: Options<JobsSyncJobEventsData, ThrowOnError>): RequestResult<JobsSyncJobEventsResponses, JobsSyncJobEventsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<JobsSyncJobEventsResponses, JobsSyncJobEventsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/sync/{job_id}/events',
    ...options
});

/**
 * Cancel Sync Job
 */
export const jobsCancelSyncJob = <ThrowOnError extends boolean = true>(options: Options<JobsCancelSyncJobData, ThrowOnError>): RequestResult<JobsCancelSyncJobResponses, JobsCancelSyncJobErrors, ThrowOnError, 'data'> => (options.client ?? client).post<JobsCancelSyncJobResponses, JobsCancelSyncJobErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/jobs/sync/{job_id}/cancel',
    ...options
});

/**
 * Read Quota Usage
 *
 * Every account's Request usage on one UTC day, per Budget.
 *
 * `day` defaults to today. Absent accounts spent nothing — the ledger only
 * holds rows for work that actually happened, so a quiet day is a short list
 * rather than a page of zeros.
 */
export const quotaReadQuotaUsage = <ThrowOnError extends boolean = true>(options?: Options<QuotaReadQuotaUsageData, ThrowOnError>): RequestResult<QuotaReadQuotaUsageResponses, QuotaReadQuotaUsageErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<QuotaReadQuotaUsageResponses, QuotaReadQuotaUsageErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/quota/usage',
    ...options
});

/**
 * Read My Quota
 *
 * Where the calling account stands on each Budget today.
 *
 * The fourth checkbox: a User sees per-Budget usage, and the browser turns
 * `status` into the persistent warning. `status` is computed here rather than
 * in the browser because the derivation is three comparisons in which zero
 * means opposite things on the two rungs, and getting it wrong client-side
 * would show "blocked" to somebody whose work is running.
 */
export const quotaReadMyQuota = <ThrowOnError extends boolean = true>(options?: Options<QuotaReadMyQuotaData, ThrowOnError>): RequestResult<QuotaReadMyQuotaResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<QuotaReadMyQuotaResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/quota/me',
    ...options
});

/**
 * Read Quota Limits
 *
 * The deployment's defaults and every per-account override.
 *
 * Both in one response: an override field rendered blank has to say which
 * number it inherits, so a screen that fetched them separately would be
 * briefly and visibly wrong.
 *
 * **Both the resolved defaults and the stored ones**, which is not
 * redundancy. The resolved pair is what is in force, `config.py` fallback
 * included, and is what a form should show as *placeholder* text. The stored
 * pair is what an Admin has actually saved, `null` where they never have, and
 * is what the form's input *value* must be. Sending only the resolved numbers
 * makes a form seed every box with the shipped value, so the first save writes
 * all six into the settings row and `QUOTA_DEFAULT_*` in `.env` goes silently
 * dead for that deployment — and "leave it empty to inherit" stops being
 * sayable, because no box is ever empty.
 */
export const quotaReadQuotaLimits = <ThrowOnError extends boolean = true>(options?: Options<QuotaReadQuotaLimitsData, ThrowOnError>): RequestResult<QuotaReadQuotaLimitsResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<QuotaReadQuotaLimitsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/quota/limits',
    ...options
});

/**
 * Set Quota Defaults
 *
 * Set the deployment-wide default allowance and ceiling per Budget.
 *
 * Written to the global `quota` settings row through `settings_store`, which
 * is the sole writer of `tg_app_settings` — a second writer here would be the
 * second opinion about where a key belongs that the two-table settings split
 * exists to remove.
 *
 * A `null` field clears that default, dropping back to `config.py`. It is
 * stored as a null rather than deleted, which `stored_default` reads as
 * absent either way.
 */
export const quotaSetQuotaDefaults = <ThrowOnError extends boolean = true>(options: Options<QuotaSetQuotaDefaultsData, ThrowOnError>): RequestResult<QuotaSetQuotaDefaultsResponses, QuotaSetQuotaDefaultsErrors, ThrowOnError, 'data'> => (options.client ?? client).put<QuotaSetQuotaDefaultsResponses, QuotaSetQuotaDefaultsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/quota/limits/defaults',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Quota Limits For User
 *
 * Override one account's allowance and ceiling on the Budgets named.
 *
 * A Budget the body omits keeps whatever override it had, so a screen editing
 * one row does not have to echo the other two back to preserve them. Sending
 * both numbers as `null` removes the override entirely, which is the only way
 * to put an account back on the deployment default.
 */
export const quotaSetQuotaLimitsForUser = <ThrowOnError extends boolean = true>(options: Options<QuotaSetQuotaLimitsForUserData, ThrowOnError>): RequestResult<QuotaSetQuotaLimitsForUserResponses, QuotaSetQuotaLimitsForUserErrors, ThrowOnError, 'data'> => (options.client ?? client).put<QuotaSetQuotaLimitsForUserResponses, QuotaSetQuotaLimitsForUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/quota/limits/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lift Quota Ceiling
 *
 * Stop enforcing this account's ceilings for the current UTC day.
 *
 * Decision 18's "an Admin can lift early". The auto-lift needs no route: the
 * ledger is keyed by day, so a ceiling stops applying at the same UTC midnight
 * the spend resets at.
 *
 * An empty `budgets` lifts all three, which is what an Admin unblocking
 * somebody in a hurry means. `lifted: false` takes it back.
 */
export const quotaLiftQuotaCeiling = <ThrowOnError extends boolean = true>(options: Options<QuotaLiftQuotaCeilingData, ThrowOnError>): RequestResult<QuotaLiftQuotaCeilingResponses, QuotaLiftQuotaCeilingErrors, ThrowOnError, 'data'> => (options.client ?? client).post<QuotaLiftQuotaCeilingResponses, QuotaLiftQuotaCeilingErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/quota/lifts/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Request Breakdown
 *
 * Requests in `[start, end)` by kind of work, by Channel and by Account.
 *
 * Times are cut to the minute and read as UTC when they carry no zone.
 * `charged` keeps only Charged or only Uncharged Requests. `accounts` keeps
 * the Requests charged to those Accounts and the Uncharged ones they asked
 * for; Uncharged Requests that name no Account stay out. `leftOut` drops
 * those Channels, by handle, and `leftOutKinds` the rows of those kinds'
 * work with no Channel. `byAccount` counts each Account's charged Requests
 * alone.
 */
export const requestsReadRequestBreakdown = <ThrowOnError extends boolean = true>(options: Options<RequestsReadRequestBreakdownData, ThrowOnError>): RequestResult<RequestsReadRequestBreakdownResponses, RequestsReadRequestBreakdownErrors, ThrowOnError, 'data'> => (options.client ?? client).get<RequestsReadRequestBreakdownResponses, RequestsReadRequestBreakdownErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/requests/breakdown',
    ...options
});

/**
 * Read Request Trend
 *
 * Requests in `[start, end)` over time, by kind of work and outcome.
 *
 * Each bucket is the finest the stored totals allow for its stretch: 5
 * minutes inside the last week, an hour inside the last `hourlyDays` days, a
 * day before. A range cut finer than its stretch allows is widened to that
 * grain; otherwise the first and last buckets are cut to the range. Times
 * `charged`, `accounts`, `leftOut` and `leftOutKinds` are read as on the
 * Breakdown.
 */
export const requestsReadRequestTrend = <ThrowOnError extends boolean = true>(options: Options<RequestsReadRequestTrendData, ThrowOnError>): RequestResult<RequestsReadRequestTrendResponses, RequestsReadRequestTrendErrors, ThrowOnError, 'data'> => (options.client ?? client).get<RequestsReadRequestTrendResponses, RequestsReadRequestTrendErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/requests/trend',
    ...options
});

/**
 * Read Request Records
 *
 * One Channel table row's Requests in `[start, end)`, newest first.
 *
 * Name the row by `channel`, a Channel's handle, or by `kind`, the kind of
 * an aggregate row (work with no Channel), never both. Each Request is kept
 * `recordDays` days, so the range is cut to them. `charged`, `accounts`,
 * `leftOut` and `leftOutKinds` are read as on the Breakdown. `hiddenKinds`
 * and `hiddenOutcomes` leave those kinds of work and outcomes out. The
 * outcome counts cover every page.
 */
export const requestsReadRequestRecords = <ThrowOnError extends boolean = true>(options: Options<RequestsReadRequestRecordsData, ThrowOnError>): RequestResult<RequestsReadRequestRecordsResponses, RequestsReadRequestRecordsErrors, ThrowOnError, 'data'> => (options.client ?? client).get<RequestsReadRequestRecordsResponses, RequestsReadRequestRecordsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/requests/records',
    ...options
});

/**
 * Read Request Spread
 *
 * When Requests were made, over everything kept, for the range picker.
 *
 * Hours inside the hourly totals' span, whole days before it, without the
 * range. `charged`, `accounts`, `leftOut` and `leftOutKinds` are read as on
 * the Breakdown.
 */
export const requestsReadRequestSpread = <ThrowOnError extends boolean = true>(options?: Options<RequestsReadRequestSpreadData, ThrowOnError>): RequestResult<RequestsReadRequestSpreadResponses, RequestsReadRequestSpreadErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<RequestsReadRequestSpreadResponses, RequestsReadRequestSpreadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/requests/spread',
    ...options
});

/**
 * Start View As
 *
 * Exchange the caller's token for a read-only look at one account.
 *
 * Refused for a target that holds `VIEW_AS` themselves — the ticket's "viewing
 * as another holder of the permission is refused", and the reason is that a
 * peer's account is the one place the permission could be used to acquire more
 * of itself. Refused for the caller's own account too: a View-as session that
 * is read-only over your *own* data is a downgrade nobody asked for, and it
 * would be indistinguishable in the audit trail from the real thing.
 *
 * Both refusals, and "no such account", answer with **one message**. A caller
 * holding `VIEW_AS` also holds `USERS_READ` and can already list every
 * account, so there is no enumeration to protect — but which accounts hold
 * which permissions is a different fact, and this route is not the place to
 * publish it.
 *
 * **Nesting needs no check of its own here, and adding one would be a guard
 * that cannot fail.** This is a POST, and `deps.view_as_allows` does not
 * allowlist it, so a View-as token is refused by `get_current_user` before the
 * handler runs. `test_view_as.py` asserts that at the HTTP level rather than
 * here — which is the assertion that survives a later widening of what an
 * elevated session may do, where an unreachable branch in this file would
 * silently become the only thing standing between an audit row and a lie.
 */
export const viewAsStartViewAs = <ThrowOnError extends boolean = true>(options: Options<ViewAsStartViewAsData, ThrowOnError>): RequestResult<ViewAsStartViewAsResponses, ViewAsStartViewAsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ViewAsStartViewAsResponses, ViewAsStartViewAsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/view-as/{user_id}',
    ...options
});

/**
 * Elevate View As
 *
 * Exchange the Owner's token for a short session that may *write* (27).
 *
 * **A second exchange, not a flag flipped on the first.** It is authorised by
 * the Owner's own token exactly as `start_view_as` is, which is what makes
 * self-escalation impossible without a check of its own: `get_current_user`
 * refuses every POST from an `act`-bearing token, so a live session cannot
 * reach this route at all, whichever mode it is in. `deps` refuses the whole
 * `/view-as` family for an elevated session on top of that, and
 * `test_view_as_elevation.py` asserts both — the belt is structural and the
 * braces are the inventory.
 *
 * **Refused for a target holding any permission at all.** The ticket says
 * "refused when the target is an Admin" and `role == "admin"` is the spelling
 * `CLAUDE.md` forbids: a fourth privileged role added as a row walks straight
 * past it. The seeded `user` role holds nothing and
 * `tests/core/test_permissions.py` asserts the default role stays that way, so
 * "holds no permission" *is* "is an ordinary User", derived rather than
 * listed — and it refuses a future read-only auditor too, which it should.
 *
 * `minutes` is chosen per exchange because elevation is not one activity with
 * one shape: a stuck setting is thirty seconds and walking somebody's import
 * is ten minutes, and an Owner forced to re-elevate repeatedly asks for the
 * maximum every time. The ceiling is validated at boot to be strictly shorter
 * than the read-only session (`Settings._enforce_elevation_is_shorter_than_looking`),
 * so the ticket's "shorter-lived than" holds for every value reachable here
 * rather than for the default alone.
 */
export const viewAsElevateViewAs = <ThrowOnError extends boolean = true>(options: Options<ViewAsElevateViewAsData, ThrowOnError>): RequestResult<ViewAsElevateViewAsResponses, ViewAsElevateViewAsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ViewAsElevateViewAsResponses, ViewAsElevateViewAsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/view-as/{user_id}/elevate',
    ...options
});

/**
 * Spend View As
 *
 * Start a session that may spend the viewed account's own resources.
 */
export const viewAsSpendViewAs = <ThrowOnError extends boolean = true>(options: Options<ViewAsSpendViewAsData, ThrowOnError>): RequestResult<ViewAsSpendViewAsResponses, ViewAsSpendViewAsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<ViewAsSpendViewAsResponses, ViewAsSpendViewAsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/view-as/{user_id}/spend',
    ...options
});

/**
 * Read View As Sessions
 *
 * Recent View-as sessions across every Owner, newest first.
 *
 * Every Owner's, not the caller's own. "There is an answer to who looked at
 * what" is the ticket's checkbox, and an answer that only covers the person
 * asking is not one.
 */
export const viewAsReadViewAsSessions = <ThrowOnError extends boolean = true>(options?: Options<ViewAsReadViewAsSessionsData, ThrowOnError>): RequestResult<ViewAsReadViewAsSessionsResponses, ViewAsReadViewAsSessionsErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<ViewAsReadViewAsSessionsResponses, ViewAsReadViewAsSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/view-as/sessions',
    ...options
});

/**
 * Read Settings Registry
 */
export const settingsReadSettingsRegistry = <ThrowOnError extends boolean = true>(options?: Options<SettingsReadSettingsRegistryData, ThrowOnError>): RequestResult<SettingsReadSettingsRegistryResponses, unknown, ThrowOnError, 'data'> => (options?.client ?? client).get<SettingsReadSettingsRegistryResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settings/registry',
    ...options
});

/**
 * Update Setting
 */
export const settingsUpdateSetting = <ThrowOnError extends boolean = true>(options: Options<SettingsUpdateSettingData, ThrowOnError>): RequestResult<SettingsUpdateSettingResponses, SettingsUpdateSettingErrors, ThrowOnError, 'data'> => (options.client ?? client).put<SettingsUpdateSettingResponses, SettingsUpdateSettingErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settings/{setting_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
